export default {
    "1": "平台店铺商品发布",
    "2": "商品发布",
    "3": "下发仓库",
    "4": "历史记录",
    "5": "类目名称",
    "6": "请选择末级节点！",
    "7": "请选择平台",
    "8": "支持搜索类目",
    "9": "商品图片",
    "10": "商品详情",
    "11": "请上传正确的视频格式！",
    "12": "视频大小不能超过50MB！",
    "13": "有一个素材正在上传中，请等待上传完成！",
    "14": "店铺授权",
    "15": "物流公司档案",
    "16": "新增逻辑仓",
    "17": "新增别名",
    "18": "新增区域",
    "19": "渠道仓档案",
    "20": "国家省市区编辑",
    "21": "别名名称",
    "22": "区域类型",
    "23": "国家",
    "24": "省份",
    "25": "市级",
    "26": "区级",
    "27": "关联国家",
    "28": "关联省",
    "29": "关联市",
    "30": "关联区县",
    "31": "区域编码",
    "32": "区域名称",
    "33": "当前修改未保存，确定返回？",
    "34": "国家省市区",
    "35": "逻辑仓编码",
    "36": "逻辑仓名称",
    "37": "所属实体仓",
    "38": "仓库类型",
    "39": "次品",
    "40": "主仓",
    "41": "负库存控制",
    "42": "店铺新增",
    "43": "店铺昵称",
    "44": "完善信息",
    "45": "下一步",
    "46": "上一步",
    "47": "授权成功",
    "48": "授权失败",
    "49": "所在区\\\\县",
    "50": "请填写店铺昵称！",
    "51": "其他平台",
    "52": "授权指引",
    "53": "渠道仓编码",
    "54": "渠道仓名称",
    "55": "添加",
    "56": "逻辑仓",
    "57": "供货比例",
    "58": "自动分配",
    "59": "供货逻辑仓",
    "60": "操作日志",
    "61": "请选择需要删除的内容！",
    "62": "不可全部删除逻辑仓数据，请至少保留一条！",
    "63": "明细不能为空！",
    "64": "请勿重复添加！",
    "65": "同一实体仓下优先级不能重复！",
    "66": "请先添加明细！",
    "67": "供货比例不能为空！",
    "68": "物流公司编码",
    "69": "物流公司名称",
    "70": "平台",
    "71": "平台物流编号",
    "72": "平台物流名称",
    "73": "前缀",
    "74": "后缀",
    "75": "平台物流对应",
    "76": "物流单号解析配置",
    "77": "删除成功！",
    "78": "内容不能为空！",
    "79": "重复数据，不能添加！",
    "80": "物流公司档案编辑",
    "81": "启用状态",
    "82": "业务信息",
    "83": "请选择需要添加的店铺类型！",
    "84": "是否授权成功？",
    "85": "商品/颜色主图",
    "86": "主图视频",
    "87": "颜色主图",
    "88": "添加图片",
    "89": "建议尺寸：800*800像素，颜色项维护请在“颜色尺寸”栏",
    "90": "视频上传教程",
    "91": "上传图片只能是 JPG,PNG,GIF 格式!",
    "92": "上传图片大小不能超过 2MB!",
    "93": "最多上传{num}张图片",
    "94": "实体仓档案",
    "95": "请输入平台",
    "96": "请输入店铺昵称",
    "97": "渠道仓编辑",
    "98": "启用",
    "99": "停用",
    "100": "授权有效时间",
    "101": "卖家姓名",
    "102": "卖家地址",
    "103": "SKU名称",
    "104": "请完成输入后回车",
    "105": "销售属性",
    "106": "币种",
    "107": "是否组合商品",
    "108": "货号",
    "109": "计算占比成功",
    "110": "计算占比失败",
    "111": "添加成分商品",
    "112": "计算占比",
    "113": "请添加组合商品",
    "114": "删除组合条码",
    "115": "组合条码编码",
    "116": "组合条码名称",
    "117": "占比",
    "118": "确定删除该组合条码?",
    "119": "商品SKU编码",
    "120": "商品SPU编码",
    "121": "当前预售数量",
    "122": "当前预售剩余数量",
    "123": "追加预售数量",
    "124": "本次调整后剩余量不允许小于0",
    "125": "追加预售数量不能为0",
    "126": "追加后预售数量",
    "127": "追加后预售剩余数量",
    "128": "请先选择需要【追加预售数量】的记录！",
    "129": "请选择其中一条记录，进行追加预售数量！",
    "130": "当前所选中明细已作废，不允许追加预售数量！",
    "131": "追加预售数量不能为空或为0！",
    "132": "活动开始时间",
    "133": "活动结束时间",
    "134": "请选择结束时间",
    "135": "平台物流编码",
    "136": "请选择需要推送WMS仓库的商品！",
    "137": "请选择下发仓库！",
    "138": "年季",
    "139": "位",
    "140": "切换类型会清空当前类型明细,是否继续?",
    "141": "规格维度信息",
    "142": "供应商名称",
    "143": "SPU编码",
    "144": "品牌",
    "145": "查找",
    "146": "重置",
    "147": "零售价",
    "148": "国际码",
    "149": "店铺",
    "150": "商品ID",
    "151": "下载",
    "152": "请选择需要下载的店铺",
    "153": "商品ID和时间必填其中一个",
    "154": "平台修改时间",
    "155": "请输入需要下载的店铺！",
    "156": "逻辑仓库",
    "157": "切换组合商品类型会清空数据，确认切换组合商品类型",
    "158": "无法修改",
    "159": "组合商品档案",
    "160": "组合商品档案编辑",
    "161": "商品相关信息",
    "162": "SPU编码由英文字母和数字组成，请合理输入",
    "163": "请选择品牌",
    "164": "价格不能为空",
    "165": "价格是一个数字，请合理输入",
    "166": "请录入条码明细后再保存",
    "167": "福袋类型组合商品一个虚拟条码不允许存在超过十个分组",
    "168": "存在每组抽取行数大于每组福袋商品总行数",
    "169": "福袋类型组合商品不允许存在一个分组超过200行的SKU",
    "170": "普通类型组合商品，一个虚拟条码下不允许超过30条SKU",
    "171": "请选择需要添加的内容！",
    "172": "组合商品编码",
    "173": "组合商品名称",
    "174": "组合类型",
    "175": "福袋",
    "176": "普通组合明细",
    "177": "福袋组合明细",
    "178": "每组抽取数",
    "179": "{str} 不能为空!",
    "180": "请勿重复添加该明细！",
    "181": "请选择需要删除的数据！",
    "182": "新增SKU",
    "183": "快速新增",
    "184": "应用到所有列",
    "185": "请选择需要生成的维度！",
    "186": "备用条码",
    "187": "SKU编辑",
    "188": "SPU编辑",
    "189": "销售状态",
    "190": "采购价",
    "191": "成本价",
    "192": "体积(cm3)",
    "193": "毛重",
    "194": "净重",
    "195": "单位",
    "196": "请选择商品分类！",
    "197": "快速生成",
    "198": "默认供应商",
    "199": "产品介绍",
    "200": "SKU信息",
    "201": "供应商",
    "202": "请选择需要添加的供应商！",
    "203": "该供应商已存在,请勿重复添加！",
    "204": "请选中需要批量应用的数据！",
    "205": "商品数量只能录入正整数",
    "206": "开始日期",
    "207": "商品维度",
    "208": "SKU基本信息",
    "209": "物理属性",
    "210": "固定属性",
    "211": "自定义属性",
    "212": "是否允许拆单",
    "213": "是否自动计算占比？",
    "214": "组合条码",
    "215": "组合商品编码、组合商品名称不能为空！",
    "216": "没有设置成分商品，请点击“添加成分商品”按钮进行设置并保存",
    "217": "数量不能为空，不允许保存",
    "218": "总占比和不等于100%，不允许保存",
    "219": "组合商品详情",
    "220": "多币种维护列表",
    "221": "新增币种成功！",
    "222": "名称已存在！",
    "223": "名称不能为空！",
    "224": "顺序号已存在！",
    "225": "没有返回新的数据ID！",
    "226": "当前记录",
    "227": "不允许追加预售数量！",
    "228": "不允许修改结束时间！",
    "229": "分类编码",
    "230": "分类名称",
    "231": "分类英文名称",
    "232": "父类",
    "233": "启用多维度规格",
    "234": "规格维度",
    "235": "一维",
    "236": "二维",
    "237": "三维",
    "238": "规格名称一",
    "239": "规格名称二",
    "240": "规格名称三",
    "241": "自定义属性名称",
    "242": "自定义属性别名",
    "243": "属性类型",
    "244": "格式不正确!",
    "245": "属性编码",
    "246": "属性名称",
    "247": "属性别名",
    "248": "属性值",
    "249": "属性形式",
    "250": "属性归属",
    "251": "请选择要删除的属性值！",
    "252": "商品SPU编辑",
    "253": "维度码",
    "254": "维度值",
    "255": "正常销售",
    "256": "暂停销售",
    "257": "提交",
    "258": "复制单据",
    "259": "商品SKU编辑",
    "260": "商品品类",
    "261": "是",
    "262": "否",
    "263": "序号",
    "264": "语言",
    "265": "全屏",
    "266": "修改密码",
    "267": "消息提示音",
    "268": "登录",
    "269": "第三方登录",
    "270": "请输入验证码",
    "271": "请输入用户名",
    "272": "请输入新密码",
    "273": "密码长度6-18位",
    "274": "密码中必须包含数字及大小写字母!",
    "275": "皮肤",
    "276": "消息",
    "277": "主题色",
    "278": "换肤",
    "279": "完成",
    "280": "确定",
    "281": "请输入",
    "282": "取消",
    "283": "平台售后单号",
    "284": "付款时间",
    "285": "请选择",
    "286": "错误",
    "287": "请输入密码",
    "288": "请按住滑块，拖动到最右侧",
    "289": "请输入手机号",
    "290": "请输入正确的手机号",
    "291": "请输入短信验证码",
    "292": "安全提示",
    "293": "当前账号登录中，是否继续登录?",
    "294": "当前密码1个月未修改，为保数据安全请立即修改!",
    "295": "重新获取",
    "296": "获取验证码成功",
    "297": "忘记密码",
    "298": "拖动滑块验证",
    "299": "验证成功",
    "300": "手机登录",
    "301": "获取验证码",
    "302": "换吊牌",
    "303": "修改退回物流公司",
    "304": "SN码",
    "305": "来源平台=旺店通，禁止修改！",
    "306": "退货入库结果单",
    "307": "无名件入库结果单",
    "308": "卡单",
    "309": "没有返回新单子的ID！",
    "310": "出库通知单",
    "311": "入库通知单",
    "312": "请选择业务单据类型",
    "313": "编码",
    "314": "名称",
    "315": "实体仓",
    "316": "下载商品",
    "317": "下载PO单",
    "318": "修改礼品卡信息",
    "319": "新增售后申请单",
    "320": "选择订单",
    "321": "补差价",
    "322": "对等换货",
    "323": "手动指定效期",
    "324": "修改预计发货时间",
    "325": "修改周期购预计发货时间",
    "326": "寻仓寻物流",
    "327": "复制权限",
    "328": "虚拟发货",
    "329": "批量设置",
    "330": "请选择需要新增售后申请单记录！",
    "331": "仅允许对仓库发货或平台发货的订单进行新增",
    "332": "JITX的订单不允许拆分！",
    "333": "非缺货、待审核订单不允许修改预计发货时间！",
    "334": "退货入库结果单-错发强制匹配",
    "335": "无名件入库结果单-错发强制匹配",
    "336": "退货入库结果单-手工匹配",
    "337": "无名件入库结果单-手工匹配",
    "338": "策略ID",
    "339": "属性ID",
    "340": "类目ID",
    "341": "请填写筛选条件或勾选要操作的数据！",
    "342": "是否确定该操作？",
    "343": "请先勾选要操作的数据！",
    "344": "是否确定转化？",
    "345": "请勾选要操作的数据！",
    "346": "是否确定对该订单进行【反审核并修改】操作？",
    "347": "是否确定删除要操作的账单？",
    "348": "请设置水印显示文字",
    "349": "预售计划单",
    "350": "修改的数据未保存,确定返回?",
    "351": "客户订单",
    "352": "请先勾选要作废的卡号信息数据！",
    "353": "请添加商品明细！",
    "354": "明细赔付金额不能为0，请重新录入！",
    "355": "是否确认执行",
    "356": "至少开启一项寻源策略！",
    "357": "组合商品编辑",
    "358": "结算策略",
    "359": "指定商品比例同步策略编辑",
    "360": "比例同步策略编辑",
    "361": "客户寻源策略编辑",
    "362": "渠道库存管理",
    "363": "逻辑解冻单",
    "364": "预盈亏",
    "365": "多渠道调拨单",
    "366": "监控平台",
    "367": "概览",
    "368": "巡检",
    "369": "全渠道自提单",
    "370": "全渠道退货扫描",
    "371": "全渠道发货单",
    "372": "全渠道退货单详情",
    "373": "全渠道订单详情",
    "374": "订单新增",
    "375": "订单详情",
    "376": "pos背景图片设置",
    "377": "线上促销活动",
    "378": "TOB寻源策略定义编辑",
    "379": "寻源策略编辑",
    "380": "请输入店铺",
    "381": "请选择付款时间!",
    "382": "拒绝换货原因",
    "383": "请选择需要拒绝的换货单！",
    "384": "换货状态不满足，不能拒绝换货！",
    "385": "拒绝换货原因请求失败",
    "386": "拒绝换货原因不能为空",
    "387": "请先选择需要拒绝换货的单据！",
    "388": "拒绝换货失败",
    "389": "商品素材",
    "390": "账单日期",
    "391": "账单日期和平台单号必须任选其一！",
    "392": "账单日期和平台单号只能任选其一！",
    "393": "百秋平台不允许下载",
    "394": "请选择需要下载的平台店铺！",
    "395": "平台宝贝ID",
    "396": "已经上传",
    "397": "条",
    "398": "排除会员导入",
    "399": "旧密码",
    "400": "请输入旧密码",
    "401": "新密码",
    "402": "密码安全程度",
    "403": "确认密码",
    "404": "两次输入的密码不一致",
    "405": "密码为8-20位，至少包含大小写字母/数字/符号 3种组合",
    "406": "低",
    "407": "新旧密码必须不一致",
    "408": "请先选择批量修改的列,然后下载模板",
    "409": "下载覆盖模板",
    "410": "请选取需要导入的文件",
    "411": "请选中要修改的字段！",
    "412": "账号登录",
    "413": "请输入账号",
    "414": "sso登录",
    "415": "找回密码",
    "416": "请输入邮箱地址",
    "417": "请输入确认密码",
    "418": "验证码",
    "419": "请填写验证码",
    "420": "取 消",
    "421": "确 定",
    "422": "请输入邮箱",
    "423": "请输入正确的邮箱",
    "424": "点击获取验证码",
    "425": "两次密码输入不一致!",
    "426": "用户名不能为空!",
    "427": "s后重新获取",
    "428": "邮箱验证码已发送",
    "429": "验证码有效时长30分钟, 失效请重新发送",
    "430": "组合条件",
    "431": "且",
    "432": "或",
    "433": "主题",
    "434": "字体",
    "435": "去除SKU字符",
    "436": "在前面",
    "437": "在后面",
    "438": "密码长度必须大于6位！",
    "439": "库存占用明细",
    "440": "设置不派单的特殊日期",
    "441": "时段",
    "442": "点击添加时间",
    "443": "结束",
    "444": "开始",
    "445": "中的结束日期不能小于开始日期！",
    "446": "选择每月盘点的日期",
    "447": "点击添加时间段",
    "448": "每月盘点日期设置",
    "449": "每日盘点时间设置",
    "450": "接单时间设置",
    "451": "营业时间设置",
    "452": "审核",
    "453": "取消审核",
    "454": "已作废",
    "455": "已盈亏",
    "456": "分货退货数量",
    "457": "已完成",
    "458": "修改单据备注",
    "459": "修改收货地址",
    "460": "加入黑名单",
    "461": "添加赠品",
    "462": "替换商品",
    "463": "修改备注",
    "464": "修改卖家备注",
    "465": "批量修改物流",
    "466": "记录发票",
    "467": "排序表单",
    "468": "订单明细",
    "469": "批量修改仓库",
    "470": "定金预售提前发货打标",
    "471": "批量替换商品",
    "472": "批量添加赠品",
    "473": "批量删除赠品",
    "474": "指定商品拆单",
    "475": "Hold单",
    "476": "入库单",
    "477": "会员加急发货打标",
    "478": "修改内部备注",
    "479": "零售发货单新增",
    "480": "请选择一条记录！",
    "481": "提示",
    "482": "请选择需要修改物流记录！",
    "483": "请选择需要修改发货仓库记录！",
    "484": "请选择需要修改备注的记录！",
    "485": "请选择需要修改内部备注的记录!",
    "486": "请选择需要定金预售提前发货的记录！",
    "487": "请选择需要加急发货的记录！",
    "488": "请选择需要替换商品的记录！",
    "489": "请选择需要添加赠品的记录！",
    "490": "请选择需要删除赠品的记录！",
    "491": "请选择需要拆单的记录！",
    "492": "请选择需要Hold单的记录！",
    "493": "请选择需要取消Hold单的记录！",
    "494": "是否确定取消Hold？",
    "495": "服务器请求失败",
    "496": "退货单新增",
    "497": "请选择需要复制的单据",
    "498": "请选择需要操作的单据！",
    "499": "批量替换下挂商品",
    "500": "只允许缺货或待审核状态的订单进行添加!",
    "501": "删除赠品",
    "502": "只允许缺货或待审核状态的订单进行添加！",
    "503": "请选择需要复制的单据！",
    "504": "售后复制",
    "505": "请先选择需要复制的订单",
    "506": "单据编号",
    "507": "失败原因",
    "508": "订单只能是原单才能复制！",
    "509": "非已取消或系统作废订单，不允许复制",
    "510": "只能对【仓库发货，平台发货】订单状态的原单进行复制操作",
    "511": "请选择一条需要复制的订单！",
    "512": "零售发货单详情",
    "513": "退换货订单新增",
    "514": "退货入库新增",
    "515": "订单拦截",
    "516": "释放库存",
    "517": "收藏",
    "518": "请至少选中一项！",
    "519": "请选择需要新增退单记录！",
    "520": "请选择需要开票的订单！",
    "521": "请选择需要取消的订单！",
    "522": "交易平台为当当，唯品会jitx，京东（货到付款）的订单不允许拆单",
    "523": "请选择需要缺货重新占单的记录！",
    "524": "请选择需要福袋缺货重新占单的记录！",
    "525": "请选择需要更改为平台发货的记录！",
    "526": "请选择要合并的单据！",
    "527": "请选择需要批量退单的记录！",
    "528": "请选择需要通知WMS的记录！",
    "529": "不支持批量操作！",
    "530": "请选中一项修改！",
    "531": "此退货入库单已经关闭匹配，不允许选择",
    "532": "是否确定批量原退？",
    "533": "只有等待售后确认状态可以强制完成！",
    "534": "是否确定强制完成？",
    "535": "退换货订单详情",
    "536": "取消状态不允许修改备注",
    "537": "单据状态是取消状态不能修改卖家备注！",
    "538": "此退换单状态不允许换货先发！",
    "539": "是否确定换货先发？",
    "540": "是否确定取消退单？",
    "541": "此退换货单已生成未作废的换货类型零售发货单，不允许取消，继续将作废换货类型零售发货单以及退换订单！",
    "542": "单据状态不符合取消条件，请重新选择",
    "543": "取消成功",
    "544": "申请数量与入库数量不一致，是否确定售后审核？",
    "545": "是否确定售后审核？",
    "546": "只有待售后审核状态的退单可以售后审核，请重新选择数据！",
    "547": "只有缺货状态订单允许缺货回传！",
    "548": "是否确定缺货回传订单！",
    "549": "开票通知编辑",
    "550": "是否确定取消订单？",
    "551": "扫描入库",
    "552": "此退换单状态不允许扫描入库,请重新选择!",
    "553": "一次只能对一个订单进行拆分！",
    "554": "订单拆分",
    "555": "只有待审核的订单可以合并",
    "556": "订单已经被HOLD，不允许合并！",
    "557": "订单为时效订单，不允许进行合并！",
    "558": "订单为预售订单且尾款未付，不允许合并！",
    "559": "合并订单最大支持合并50单！",
    "560": "确认将选中的订单合并吗？",
    "561": "成功",
    "562": "未合并的订单不允许进行取消合并！",
    "563": "只允许待审核的订单进行取消合并！",
    "564": "确认将选中的订单取消合并吗？",
    "565": "订单需要生成退换货单的订单状态不能已取消、系统作废！",
    "566": "订单需要发货后才能新增退单！",
    "567": "订单状态为仓库发货和平台发货才能新增退单！",
    "568": "请选择不超过80笔订单的数据！",
    "569": "只允许仓库发货、平台发货状态订单批量退单！",
    "570": "当前的操作会执行手动入库，是否继续？",
    "571": "虚拟仓库入库失败！",
    "572": "报错信息",
    "573": "选择的订单中存在非待审核订单,不允许释放库存！",
    "574": "是否确定将选择的订单占用的库存释放？",
    "575": "额外退款编辑",
    "576": "只有仓库发货或者平台发货的订单才能操作！",
    "577": "订单状态已审核，建议反审核再修改地址！",
    "578": "订单状态非未确认、缺货、已审核、配货中，不允许修改地址！",
    "579": "地址信息获取失败！",
    "580": "有一项导出正在进行中！",
    "581": "审核失败",
    "582": "多次缺货",
    "583": "缺货",
    "584": "请确认是否重传WMS？",
    "585": "只支持单个退货单做WMS撤回重做操作！",
    "586": "发货店仓",
    "587": "收货仓库",
    "588": "手机号不能为空！",
    "589": "手机号格式不正确！",
    "590": "收货人地址不能为空！",
    "591": "收货人地址格式不正确！",
    "592": "下单店铺",
    "593": "配送费用",
    "594": "平台单号",
    "595": "付款方式",
    "596": "代收金额",
    "597": "收货人",
    "598": "收货人手机",
    "599": "收货人省份",
    "600": "收货人市",
    "601": "收货人地址",
    "602": "不能为空！",
    "603": "手机号码必须为数字,请修改",
    "604": "实体仓库为必填项，请填写后保存！",
    "605": "实际赔付金额为必填项，请填写后保存！",
    "606": "支付方式不能为空！",
    "607": "原平台单号不能为空！",
    "608": "支付账号不能为空！",
    "609": "失败！",
    "610": "警告",
    "611": "新增",
    "612": "编辑",
    "613": "已提交",
    "614": "已结案",
    "615": "手机",
    "616": "嗨淘",
    "617": "TOP平台",
    "618": "普通淘宝",
    "619": "聚划算",
    "620": "正常",
    "621": "换货",
    "622": "补发",
    "623": "预售",
    "624": "虚拟",
    "625": "指定买赠",
    "626": "全场买赠",
    "627": "下单时间",
    "628": "定金时间",
    "629": "买家备注",
    "630": "卖家备注",
    "631": "不限制",
    "632": "限制",
    "633": "非搭配商品",
    "634": "搭配商品",
    "635": "选系统SKU",
    "636": "选平台SKU",
    "637": "选系统SPU",
    "638": "选平台SPU",
    "639": "包含以下商品",
    "640": "排除以下商品",
    "641": "数量阶梯",
    "642": "金额阶梯",
    "643": "不翻倍",
    "644": "翻倍",
    "645": "全部送",
    "646": "顺序送",
    "647": "随机送",
    "648": "买商品列表不同商品",
    "649": "买商品列表任意商品",
    "650": "指定商品总金额",
    "651": "订单总金额",
    "652": "单行单梯度数量",
    "653": "多梯度统一总量",
    "654": "复制成功！",
    "655": "商品SKU",
    "656": "商品款号",
    "657": "数量",
    "658": "请输入商品！",
    "659": "只能选取一条数据",
    "660": "不存在该商品！",
    "661": "弹框多选",
    "662": "该记录已在已选中列表中！",
    "663": "模板名称不能为空！",
    "664": "保存成功！",
    "665": "查询数量已超过上限，请修改查询条件！",
    "666": "请先选择",
    "667": "数据加载中...",
    "668": "暂无数据",
    "669": "导入",
    "670": "请选择需要导入的文件！",
    "671": "导入失败,详情见文件内容",
    "672": "文件最大64M！",
    "673": "标题",
    "674": "刷新",
    "675": "新增明细",
    "676": "删除明细",
    "677": "导出",
    "678": "组合福袋商品编辑",
    "679": "商品SPU",
    "680": "SKU快速生成",
    "681": "商品自定义属性",
    "682": "组合商品",
    "683": "商品分类",
    "684": "共享池库存梯度策略",
    "685": "配销仓库存梯度策略",
    "686": "寻源策略定义",
    "687": "店仓评分设置表",
    "688": "物流区域设置新增",
    "689": "零售发货单",
    "690": "退换货单",
    "691": "退货单详情",
    "692": "已发货退款单编辑",
    "693": "JIT配货单-换吊牌",
    "694": "退换货新增",
    "695": "促销活动",
    "696": "仓库物流优先级方案新增",
    "697": "快递赔付方案编辑",
    "698": "订单自动审核编辑",
    "699": "发货单派单规则",
    "700": "唯品会预警通知",
    "701": "档期日程规划",
    "702": "仓库物流设置",
    "703": "商品价格策略",
    "704": "直播解析策略",
    "705": "分仓规则",
    "706": "分物流规则",
    "707": "特殊物流方案",
    "708": "物流派送范围",
    "709": "HOLD单策略",
    "710": "天猫换货策略",
    "711": "审单策略",
    "712": "返回",
    "713": "保存",
    "714": "发票属性",
    "715": "请选中一条数据！",
    "716": "订单下载",
    "717": "接口下载任务表编辑",
    "718": "接口下载任务表",
    "719": "查询时间",
    "720": "订单状态",
    "721": "已审核",
    "722": "未发货取消",
    "723": "请输入平台单号",
    "724": "请选择订单状态",
    "725": "等待出库",
    "726": "多个平台单号，用逗号分隔",
    "727": "请选择输入的日期或输入订单编号",
    "728": "退单修改时间",
    "729": "服务单号",
    "730": "退单修改时间不存在时, 平台单号、服务单号必须同时有！",
    "731": "退单修改时间存在时,平台单号、服务单号必须为空！",
    "732": "退款申请时间",
    "733": "请输入退款申请时间！",
    "734": "新建",
    "735": "确认中",
    "736": "确认为JITX",
    "737": "确认为非JITX",
    "738": "请选择下单时间！",
    "739": "下单时间范围不能超过半小时，请重新设置！",
    "740": "请选择输入日期或输入订单编号",
    "741": "请输入平台修改时间或平台单号！",
    "742": "退单修改时间和退单单号不能同时为空",
    "743": "平台退款单号",
    "744": "换货单状态",
    "745": "换货待处理",
    "746": "换货单修改时间",
    "747": "平台换货单号",
    "748": "换单修改时间和换单单号不能同时为空",
    "749": "待发货",
    "750": "退单状态",
    "751": "待卖家同意",
    "752": "平台退货单号",
    "753": "平台时间",
    "754": "退供单号",
    "755": "多个退供单号，用逗号隔开",
    "756": "请输入平台时间或退供单号",
    "757": "商品数字ID",
    "758": "请输入需要下载的数字编号或修改时间中的一个",
    "759": "店铺和平台时间不能为空",
    "760": "PO编号",
    "761": "密码登录",
    "762": "验证码登录",
    "763": "欢迎登录",
    "764": "账号",
    "765": "密码",
    "766": "上传文件",
    "767": "数据正在导入中，请稍候...",
    "768": "订单下载任务已经发送，任务ID：",
    "769": "，请前往接口下载任务表查看下载进度！",
    "770": "查询结果",
    "771": "有效数据起始行",
    "772": "只能输入正整数",
    "773": "AK重复是否更新已有记录",
    "774": "注意：上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。",
    "775": "下载模版",
    "776": "追加到原备注",
    "777": "日志服务请求失败!",
    "778": "隐藏当前列",
    "779": "重置所有列位置信息",
    "780": "全选",
    "781": "开启",
    "782": "点击此处，或标签页横向滚动切换",
    "783": "图例",
    "784": "提交状态",
    "785": "草稿状态",
    "786": "下线/过期状态",
    "787": "过期",
    "788": "换票类型",
    "789": "原发票信息",
    "790": "修改发票信息",
    "791": "收票信息",
    "792": "已选中{total}条数据",
    "793": "点击上传",
    "794": "已选中{num}条",
    "795": "所属大类",
    "796": "请输入SPU编码",
    "797": "编号",
    "798": "店仓编码",
    "799": "读入装箱标准",
    "800": "该记录已在已选中列表中",
    "801": "模板名称不能为空",
    "802": "查询数量已超过上限，请修改查询条件",
    "803": "加载中",
    "804": "文件名",
    "805": "导出位置",
    "806": "数据正在导入中，请稍候",
    "807": "下载报错信息",
    "808": "第{num}条记录报错",
    "809": "请选择要导入的文件",
    "810": "文件最大",
    "811": "退出全屏",
    "812": "退出",
    "813": "输入值不能大于{num}位数",
    "814": "该矩形框表示︰条码档案不存在该条码",
    "815": "信息筛选",
    "816": "请填写完整",
    "817": "已选条件",
    "818": "会员高级搜索",
    "819": "会员卡号",
    "820": "男",
    "821": "女",
    "822": "保密",
    "823": "会员类型/等级",
    "824": "开卡日期",
    "825": "地区",
    "826": "可用积分",
    "827": "是否关注公众号",
    "828": "未关注",
    "829": "已关注",
    "830": "已取关",
    "831": "微信小程序是否绑卡",
    "832": "微信会员卡是否绑卡",
    "833": "淘宝是否绑卡",
    "834": "会员标签",
    "835": "消费属性",
    "836": "最近一次消费日期",
    "837": "累计消费金额",
    "838": "消费次数",
    "839": "次",
    "840": "平均客单价",
    "841": "生命周期",
    "842": "新老会员",
    "843": "新会员",
    "844": "老会员",
    "845": "活跃程度",
    "846": "活跃会员",
    "847": "不活跃会员",
    "848": "沉睡会员",
    "849": "流失会员",
    "850": "搜索成功",
    "851": "标签分类",
    "852": "已选中",
    "853": "贴标签成功",
    "854": "请选择一种或多种",
    "855": "请选择会员类型",
    "856": "请选择会员等级",
    "857": "多个或",
    "858": "一个",
    "859": "已匹配到{num}位会员",
    "860": "请导入",
    "861": "导入成功{msg}位",
    "862": "开卡店仓",
    "863": "yyyy 年 MM 月 dd 日",
    "864": "(含）至",
    "865": "请选择累计月份",
    "866": "累计",
    "867": "近{num}个月",
    "868": "请添加标签",
    "869": "选择标签",
    "870": "请前往接口下载任务表查看下载进度！",
    "871": "手机位数不正确,请修改",
    "872": "请选择发货配销仓",
    "873": "请选择发货逻辑仓",
    "874": "条码明细中【数量】【退货价】只有在【单据状态】为【待审核】时才能编辑，现获取【单据状态(ORDER_STATUS)】失败！",
    "875": "订单取消成功",
    "876": "条失败",
    "877": "【商品素材】版本",
    "878": "更多筛选",
    "879": "筛选条件",
    "880": "添加条件",
    "881": "筛选结果",
    "882": "查看选中结果",
    "883": "全局检索",
    "884": "保存为模板",
    "885": "模板名称",
    "886": "选择文件",
    "887": "详细信息",
    "888": "是否确定作废选中的【{}】条卡号信息？",
    "889": "共{}条",
    "890": "时段{}中的{}时间不能为空！",
    "891": "其他",
    "892": "库存不足或商品已下架",
    "893": "申请时间已超7天无理由退换货时限",
    "894": "定制商品不支持换货",
    "895": "不符合商品完好标准",
    "896": "非包邮商品运费未达成一致",
    "897": "与买家达成一致",
    "898": "所换商品差价，未协商一致",
    "899": "批量签收",
    "900": "修改SN/IMEI信息",
    "901": "待交接",
    "902": "第{}条记录报错：",
    "903": "商品标签",
    "904": "不支持的文件格式'{type}'!",
    "905": "配货完成",
    "906": "LMA工单详情",
    "907": "换店",
    "908": "支付宝账户名称",
    "909": "下载方式",
    "910": "按日下载",
    "911": "按月下载",
    "912": "账单时间",
    "913": "请选择需要下载的支付宝账户名称",
    "914": "请选择需要下载的账单时间",
    "915": "节点类型",
    "916": "售中",
    "917": "售后",
    "918": "请选择节点类型！",
    "919": "费用类型",
    "920": "费用类型不能为空！",
    "921": "Accounting Treatment 不能为空！",
    "922": "失败!",
    "923": "手机号格式不正确!",
    "924": "发票种类",
    "925": "发票类型",
    "926": "输入平台单号后请回车",
    "927": "请选择需要申请换票的单据记录！",
    "928": "换票的单据只能选择一条订单发票！",
    "929": "选择的订单已经取消，不能申请换票！",
    "930": "选择的订单已经冻结，不能申请换票！",
    "931": "平台单号最多可添加20条！",
    "932": "该平台单号已添加！",
    "933": "对账日期",
    "934": "请选择需要分摊的逻辑调拨单范围",
    "935": "请选择需要分摊的零售发货单范围",
    "936": "请选择需要重算的对账单范围",
    "937": "请选择仓库",
    "938": "请选择对账日期",
    "939": "请勾选一条报价！",
    "940": "您勾选了无效的报价！",
    "941": "自动生成（PTZDDR—年+月+日+0001）",
    "942": "自动生成",
    "943": "平台订单导入编码",
    "944": "创建时间",
    "945": "所属店铺",
    "946": "所属平台",
    "947": "账单起始日期",
    "948": "账单截止日期",
    "949": "上账时间",
    "950": "账单文件类型",
    "951": "平台账单文件",
    "952": "通用账单文件",
    "953": "备注",
    "954": "仅支持导入csv、xlsx、xls格式的文件，请重新选择！",
    "955": "请选择所属店铺！",
    "956": "请选择账单起始日期！",
    "957": "请选择账单截止日期！",
    "958": "请选择上账时间！",
    "959": "备注长度不能大于200字符！",
    "960": "请选择需要下载的查询时间",
    "961": "下载失败",
    "962": "产生费用单",
    "963": "新增产生费用单",
    "964": "账单时间必须选择！",
    "965": "确认责任方",
    "966": "责任方",
    "967": "是否已收到赔付",
    "968": "单据业务类型编码",
    "969": "单据类型",
    "970": "订单",
    "971": "退单",
    "972": "单据类型不能为空！",
    "973": "单据编号不能为空！",
    "974": "指定总额",
    "975": "填写总额，系统按照此账单的个品项销售额占比分摊总额。",
    "976": "指定SKU",
    "977": "将总额分摊到指定的SKU上。",
    "978": "请填写正确的金额！",
    "979": "金额不能超过总金额的50% ！",
    "980": "请填写金额！",
    "981": "请填写指定的SKU！",
    "982": "条记录",
    "983": "暂未添加平台单号数据",
    "984": "发票信息",
    "985": "通用模板下载",
    "986": "更新文件",
    "987": "未选择任何文件",
    "988": "汇总年月不能为空",
    "989": "请求成功！",
    "990": "汇总年月",
    "991": "待拆列表",
    "992": "原始单号",
    "993": "客户",
    "994": "订单数量",
    "995": "拆单数量",
    "996": "查看发票不支持选择多条订单，只能选择一条查看!",
    "997": "请输入识别内容",
    "998": "请在输入后按回车",
    "999": "全部",
    "1000": "待开票",
    "1001": "开票中",
    "1002": "已冻结",
    "1003": "已取消",
    "1004": "开票成功",
    "1005": "开票失败",
    "1006": "已冲红",
    "1007": "财审确认",
    "1008": "换纸质",
    "1009": "换专票",
    "1010": "换抬头",
    "1011": "电子发票",
    "1012": "纸质发票",
    "1013": "普票",
    "1014": "专票",
    "1015": "抬头类型",
    "1016": "个人",
    "1017": "企业",
    "1018": "发票抬头",
    "1019": "开票金额",
    "1020": "地址",
    "1021": "纳税人识别号",
    "1022": "电话号码",
    "1023": "开户银行",
    "1024": "银行账号",
    "1025": "发票备注",
    "1026": "收票人",
    "1027": "收票人地址",
    "1028": "邮箱",
    "1029": "仓库",
    "1030": "导入成功",
    "1031": "导入失败",
    "1032": "立即下载",
    "1033": "账单编码",
    "1034": "账单时间账单编码不能同时为空！",
    "1035": "账单时间不能为空",
    "1036": "账单时间不能跨月",
    "1037": "账单时间段天数要小于等于11天",
    "1038": "月结账单下载",
    "1039": "进度账单下载",
    "1040": "供应商ID",
    "1041": "生成",
    "1042": "供应商ID不能为空！",
    "1043": "账单编码不能为空",
    "1044": "店铺名称",
    "1045": "店铺名称不能为空！",
    "1046": "快递单号",
    "1047": "快递公司",
    "1048": "订单编号",
    "1049": "出库日期",
    "1050": "快递公司名称",
    "1051": "实体仓名称",
    "1052": "顾客电话不合法！",
    "1053": "财审",
    "1054": "客审",
    "1055": "丢件单",
    "1056": "上传凭证",
    "1057": "商品条码",
    "1058": "标准价",
    "1059": "实际成交价",
    "1060": "应付金额",
    "1061": "快递网点",
    "1062": "丢件类型",
    "1063": "丢件原因",
    "1064": "支付方式",
    "1065": "来源单据编号",
    "1066": "调整类型",
    "1067": "顾客姓名",
    "1068": "顾客电话",
    "1069": "会员昵称",
    "1070": "原单金额",
    "1071": "总应付金额",
    "1072": "原始出库日期",
    "1073": "责任人",
    "1074": "原因备注",
    "1075": "创建人",
    "1076": "修改人",
    "1077": "修改时间",
    "1078": "数量只能录入正整数！",
    "1079": "应收单价",
    "1080": "应付金额只能录入大于0的数字！",
    "1081": "日志内容",
    "1082": "操作姓名",
    "1083": "操作时间",
    "1084": "赔付单明细",
    "1085": "赔付原因",
    "1086": "已客审",
    "1087": "已财审",
    "1088": "基本信息",
    "1089": "保存失败！",
    "1090": "请选择明细后再点击删除",
    "1091": "丢件单新增",
    "1092": "作废",
    "1093": "查询条件设置",
    "1094": "单据状态",
    "1095": "赔付快递公司",
    "1096": "支付宝号",
    "1097": "客审时间",
    "1098": "客审人",
    "1099": "财审时间",
    "1100": "财审人",
    "1101": "作废时间",
    "1102": "作废人",
    "1103": "可用",
    "1104": "传DRP状态",
    "1105": "反客审成功！",
    "1106": "列表没有数据,无法导出！",
    "1107": "导出成功",
    "1108": "是否自动结算",
    "1109": "结算产生时间",
    "1110": "每天",
    "1111": "每月",
    "1112": "每年",
    "1113": "单据业务类型",
    "1114": "是否参与对账",
    "1115": "是否产生结算单",
    "1116": "结算类型",
    "1117": "首字符",
    "1118": "流水号位数",
    "1119": "参与对账单据类型",
    "1120": "日志",
    "1121": "修改的数据未保存,确定刷新",
    "1122": "结算类型不能为空, 请选择！",
    "1123": "结算单产生汇总方式",
    "1124": "结算单单号规则",
    "1125": "新增应付调整单明细",
    "1126": "收款账号",
    "1127": "请选着一条数据！",
    "1128": "丢件单详情",
    "1129": "平台单号不能为空！",
    "1130": "共{}件",
    "1131": "历史TP",
    "1132": "未定义",
    "1133": "快递仓储",
    "1134": "业审",
    "1135": "电子",
    "1136": "查询条件【平台店铺、平台条码ID、平台商品ID、条码、SPU编码、商品状态、同步状态、同步失败原因】至少选择一个！",
    "1137": "代收货款",
    "1138": "京东无界通用模板",
    "1139": "京东无界自营模板",
    "1140": "收件",
    "1141": "寄件",
    "1142": "服务",
    "1143": "签收人：",
    "1144": "时间：",
    "1145": "商家自定义区",
    "1146": "已视验",
    "1147": "客户信息",
    "1148": "客户签字",
    "1149": "应收金额",
    "1150": "请您确认包裹完好,保留此包裹联时,代表您已经正常签收并确认外包裹完好。http://www.jd-ex.com客服电话:400-603-3600",
    "1151": "查询条件 <实体仓> <单据日期> <来源单据类型> 至少有一个不为空.",
    "1152": "历史快照",
    "1153": "请输入需要同步的批次！",
    "1154": "批次号",
    "1155": "请输入批次号",
    "1156": "是否删除模板不存在记录",
    "1157": "绑定",
    "1158": "渠道层",
    "1159": "配销层",
    "1160": "聚合层",
    "1161": "逻辑层",
    "1162": "物理层",
    "1163": "请至少选择一个查询条件",
    "1164": "确定根据查询条件重传WMS?",
    "1165": "请输入驳回原因",
    "1166": "请输入内容",
    "1167": "配销仓",
    "1168": "选择日期",
    "1169": "设置库存同步的逻辑仓范围",
    "1170": "添加店仓",
    "1171": "下载导入模板",
    "1172": "请输入店仓名称",
    "1173": "收货店仓",
    "1174": "提交生成相应调拨单",
    "1175": "下载模板",
    "1176": "库存按查询条件同步",
    "1177": "商品按查询条件同步",
    "1178": "确定打印",
    "1179": "杭州",
    "1180": "打印",
    "1181": "正在打印中，请稍后。。。",
    "1182": "平台店铺",
    "1183": "请输入平台店铺",
    "1184": "请输入备注",
    "1185": "比例",
    "1186": "请输入配销仓",
    "1187": "请输入优先级",
    "1188": "共享池",
    "1189": "请输入共享池",
    "1190": "请输入共享池比例",
    "1191": "库存发布",
    "1192": "确认停用吗",
    "1193": "确认启用吗",
    "1194": "比例同步策略",
    "1195": "确认执行作废",
    "1196": "配销仓明细",
    "1197": "有一项导出正在进行中",
    "1198": "本次操作已后台处理，是否至[我的任务]查看",
    "1199": "数值越大，优先级越高",
    "1200": "结案",
    "1201": "请先选择需要删除的记录!",
    "1202": "确认执行审核？",
    "1203": "创建日期",
    "1204": "来源单号",
    "1205": "处理状态",
    "1206": "创建日期不能为空",
    "1207": "时间范围不能超过24小时",
    "1208": "【平台条码id、条码、批次编码】不能同时为空！",
    "1209": "批次编号",
    "1210": "店铺ID",
    "1211": "同步状态",
    "1212": "未审核",
    "1213": "是否错误",
    "1214": "同步库存数",
    "1215": "返回信息",
    "1216": "计算虚高库存前库存",
    "1217": "扩展属性",
    "1218": "平台商品ID不能为空！",
    "1219": "批次编号,平台商品ID,平台条码ID,条码编码中需最少一项不为空!",
    "1220": "平台店铺标题",
    "1221": "期初可售数",
    "1222": "变化数量",
    "1223": "期末可售数",
    "1224": "店铺不能为空！",
    "1225": "条码不能为空！",
    "1226": "清空条件",
    "1227": "下载平台商品",
    "1228": "下载平台库存",
    "1229": "是否确定全量库存同步",
    "1230": "当前选中记录无差异数，无需同步",
    "1231": "是否确认增量同步库存",
    "1232": "需要重新下载最新库存，不能产生增量同步",
    "1233": "是否确定修改同步比例",
    "1234": "平台商品",
    "1235": "是否转仓",
    "1236": "同步库存",
    "1237": "上架状态",
    "1238": "商品类型",
    "1239": "同步比例",
    "1240": "渠道内配销仓库存",
    "1241": "渠道外配销仓库存",
    "1242": "店铺库存",
    "1243": "中台系统当前店铺的库存",
    "1244": "计算状态",
    "1245": "平台库存",
    "1246": "线上平台当前店铺的库存",
    "1247": "平台库存下载时间",
    "1248": "差异数",
    "1249": "店铺库存 - 平台库存",
    "1250": "配销仓库存",
    "1251": "供货配销仓的可用库存的合计",
    "1252": "安全库存",
    "1253": "店铺当前平台条码ID的保底量",
    "1254": "最后同步数",
    "1255": "最后同步时间",
    "1256": "同步失败的原因",
    "1257": "平台条码",
    "1258": "传TMS失败",
    "1259": "传DRP失败",
    "1260": "传WMS失败",
    "1261": "WMS实缺",
    "1262": "当前平台单号存在多个零售发货单，请进入零售发货单页面查找查看",
    "1263": "打开",
    "1264": "生效",
    "1265": "已调度",
    "1266": "待发运",
    "1267": "在途",
    "1268": "签收",
    "1269": "已回单",
    "1270": "合计",
    "1271": "请输入调入量",
    "1272": "活动",
    "1273": "请选择商品类型",
    "1274": "来源配销仓",
    "1275": "配销仓类型",
    "1276": "来源仓库存",
    "1277": "占用数",
    "1278": "可用数",
    "1279": "来源聚合仓",
    "1280": "调入库存",
    "1281": "来源共享池",
    "1282": "请输入平台商品ID",
    "1283": "请选择修改时间",
    "1284": "计算完成",
    "1285": "计算中",
    "1286": "未同步",
    "1287": "同步成功",
    "1288": "同步失败",
    "1289": "未勾选记录，不允许继续操作",
    "1290": "操作成功",
    "1291": "共享池档案",
    "1292": "确认执行删除",
    "1293": "折扣",
    "1294": "是否保存已经修改的数据",
    "1295": "删除明细成功",
    "1296": "修改折扣成功",
    "1297": "请维护折扣！",
    "1298": "请维护价格！",
    "1299": "匹配成功",
    "1300": "请输入数量",
    "1301": "请先选择店仓",
    "1302": "单条码新增成功",
    "1303": "未开始",
    "1304": "导入中",
    "1305": "逻辑调拨",
    "1306": "非逻辑调拨",
    "1307": "逻辑调拨单批量导入",
    "1308": "聚合仓调拨单",
    "1309": "聚合仓到配销仓调拨单",
    "1310": "配销仓调拨单",
    "1311": "配销仓到聚合仓调拨单",
    "1312": "当前当前数据还在导入中，请稍后再次导入",
    "1313": "店仓",
    "1314": "创建拣货单",
    "1315": "来源平台",
    "1316": "范围时间",
    "1317": "请输入策略名称",
    "1318": "请输入范围时间",
    "1319": "评分策略",
    "1320": "请输入评分策略",
    "1321": "确认取消审核？",
    "1322": "该实体仓已存在!",
    "1323": "当前页有未保存数据，是否需要保存？",
    "1324": "确认执行结案",
    "1325": "来源平台和平台店铺不能均为空",
    "1326": "【仓优先】中\"\"实体仓\"\"为空，不允许保存!",
    "1327": "【仓优先】中\"\"优先级\"\"为空，不允许保存!",
    "1328": "请输入实体店仓",
    "1329": "库存同步",
    "1330": "判断条件",
    "1331": "开始值",
    "1332": "请先选择需要作废的记录！",
    "1333": "本次操作已后台处理，是否至[我的任务]查看?",
    "1334": "是否确认同步库存？",
    "1335": "是否打印选中行？",
    "1336": "驳回原因",
    "1337": "分货确认单",
    "1338": "共享库存",
    "1339": "独享库存",
    "1340": "查询条件",
    "1341": "独享库存明细",
    "1342": "共享库存明细",
    "1343": "生成盈亏",
    "1344": "盘点日期",
    "1345": "预盈亏明细按条码",
    "1346": "当前的操作会执行全量导出，导出时间可能会比较慢！是否继续导出？",
    "1347": "盘点店仓",
    "1348": "调整性质",
    "1349": "盘点类型",
    "1350": "全盘",
    "1351": "抽盘",
    "1352": "历史盘",
    "1353": "盈亏状态",
    "1354": "店仓名称",
    "1355": "预盈亏明细",
    "1356": "分类全盘",
    "1357": "未盈亏",
    "1358": "请选择店仓",
    "1359": "请选择类型",
    "1360": "请选择日期",
    "1361": "盈亏单",
    "1362": "生成盈亏后台处理中，请稍后查看盈亏结果",
    "1363": "盘盈",
    "1364": "盘亏",
    "1365": "串码",
    "1366": "停止/开启平台库存同步",
    "1367": "设定安全库存",
    "1368": "商家条码id",
    "1369": "来源聚合仓名称",
    "1370": "来源配销仓名称",
    "1371": "调入量",
    "1372": "修改商品标签",
    "1373": "修改同步比例",
    "1374": "收起列表",
    "1375": "显示列表",
    "1376": "收起矩阵",
    "1377": "显示矩阵",
    "1378": "批量修改折扣",
    "1379": "修改类型",
    "1380": "匹配在库",
    "1381": "匹配库存不足商品",
    "1382": "匹配可用",
    "1383": "发货可用",
    "1384": "发货在库",
    "1385": "在库",
    "1386": "收货可用",
    "1387": "收货在途",
    "1388": "零售数量",
    "1389": "行合计",
    "1390": "输入值不能大于4位数",
    "1391": "该矩形框表示︰条码档案不存在该条码！",
    "1392": "请输入SKU、SPU编码",
    "1393": "收货在库",
    "1394": "输入值不能大于7位数",
    "1395": "调拨类型",
    "1396": "导入状态",
    "1397": "发货方编码",
    "1398": "发货方名称",
    "1399": "收货方编码",
    "1400": "申请调拨数量",
    "1401": "实际调拨数量",
    "1402": "聚合调拨数量",
    "1403": "分货数量",
    "1404": "操作日期",
    "1405": "单据是否完成",
    "1406": "强制寻源规则",
    "1407": "仓优先",
    "1408": "新增行",
    "1409": "删除行",
    "1410": "总数量",
    "1411": "批次编号,平台商品ID,平台条码ID,条码中需最少一项不为空!",
    "1412": "分销",
    "1413": "请选择经营模式",
    "1414": "请输入逻辑仓",
    "1415": "客户寻源策略",
    "1416": "库存梯度",
    "1417": "输入开始值后，回车保存",
    "1418": "添加店铺明细",
    "1419": "删除库存梯度",
    "1420": "请输入判断条件和开始值",
    "1421": "请在输入框“开始值”回车保存",
    "1422": "请输入店铺和比例",
    "1423": "点击【保存】后落库",
    "1424": "当前没有可清空的店仓！",
    "1425": "确认清空所有店仓？",
    "1426": "匹配",
    "1427": "当前页面是{}，确定切换为其他调拨类型吗？",
    "1428": "已选中{}条数据",
    "1429": "寻源优先级",
    "1430": "请输入配销仓比例",
    "1431": "确认执行结案？",
    "1432": "修改商品类型",
    "1433": "全量库存同步",
    "1434": "是否确定全量库存同步？",
    "1435": "手动增量同步库存",
    "1436": "是否确定修改同步比例？",
    "1437": "下载全店在售库存",
    "1438": "全量同步全店库存（在售）",
    "1439": "保存成功",
    "1440": "指定店铺",
    "1441": "公共",
    "1442": "请选择来源平台",
    "1443": "平台店铺为空，不允许保存！",
    "1444": "确认执行库存同步？",
    "1445": "盘点性质",
    "1446": "指定商品比例同步策略",
    "1447": "实际盘点数量",
    "1448": "收货逻辑仓",
    "1449": "实体仓逻辑",
    "1450": "零售开始时间",
    "1451": "零售结束时间",
    "1452": "销售类型",
    "1453": "发货逻辑仓",
    "1454": "是否确认同步页面",
    "1455": "订单正向",
    "1456": "订单逆向",
    "1457": "已选择的任务",
    "1458": "信息类型",
    "1459": "类型划分",
    "1460": "任务分类",
    "1461": "任务名称",
    "1462": "任务说明",
    "1463": "主数据",
    "1464": "中台系统监控",
    "1465": "选择任务",
    "1466": "更新时间",
    "1467": "对外接口监控",
    "1468": "信息推送",
    "1469": "信息接收",
    "1470": "信息取消",
    "1471": "信息回传",
    "1472": "中台",
    "1473": "暂无异常数据",
    "1474": "最近菜单",
    "1475": "添加常用菜单",
    "1476": "搜索菜单的名称",
    "1477": "你可能想添加",
    "1478": "预警",
    "1479": "更新",
    "1480": "今日数据",
    "1481": "通知消息",
    "1482": "默认",
    "1483": "柱状图",
    "1484": "即将超时订单",
    "1485": "超时订单",
    "1486": "待拦截订单",
    "1487": "售后传wms异常单",
    "1488": "售后异常",
    "1489": "待售后审核",
    "1490": "单数",
    "1491": "通知",
    "1492": "链接",
    "1493": "营销活动",
    "1494": "任务详细说明",
    "1495": "最多只能选择{}个任务",
    "1496": "公告信息",
    "1497": "公告",
    "1498": "尺码",
    "1499": "唯品会专配",
    "1500": "顺丰陆运",
    "1501": "航空禁运",
    "1502": "入库单结单时间",
    "1503": "异常类型",
    "1504": "省",
    "1505": "市",
    "1506": "平台类型",
    "1507": "平台省市区",
    "1508": "卡单原因",
    "1509": "卡单时间",
    "1510": "卡单原因不能为空",
    "1511": "错误信息",
    "1512": "备注内容不能全是空格！",
    "1513": "非唯品会专配",
    "1514": "唯品会入库单不能为空",
    "1515": "请选择预计发货时间",
    "1516": "请选择预计到货时间",
    "1517": "到货时间小于预计发货时间",
    "1518": "修改成功",
    "1519": "请勾选需要处理的异常商品",
    "1520": "规格1",
    "1521": "规格2",
    "1522": "此商品中不存在该规格1和规格2",
    "1523": "正品",
    "1524": "仓库名称",
    "1525": "入库实体仓库",
    "1526": "请选择仓库!",
    "1527": "平台规格ID",
    "1528": "平台商品ID",
    "1529": "平台商品名称",
    "1530": "系统SKU编码",
    "1531": "商家商品编码",
    "1532": "商家规格编码",
    "1533": "系统SKU名称",
    "1534": "规格",
    "1535": "是否为赠品",
    "1536": "请添加并选择替换商品！",
    "1537": "可录入多个拣货单号，用逗号分隔",
    "1538": "物流公司不能为空!",
    "1539": "覆盖原备注",
    "1540": "JIT配货单",
    "1541": "拣货单号",
    "1542": "原始条码",
    "1543": "实际条码",
    "1544": "拣货数",
    "1545": "撤回",
    "1546": "替换",
    "1547": "实际条码为空或不正确",
    "1548": "数量不能为空",
    "1549": "数量格式不正确",
    "1550": "实际条码的总拣货数超过了原始条码的拣货数",
    "1551": "请选择需要删除明细",
    "1552": "当前无任何修改，不执行保存！",
    "1553": "手机号不能为空!",
    "1554": "收货人地址不能为空!",
    "1555": "收货人地址格式不正确!",
    "1556": "平台业务类型",
    "1557": "发货仓库",
    "1558": "收货人邮费",
    "1559": "收件人公司",
    "1560": "收件人门牌号",
    "1561": "添加商品SKU",
    "1562": "颜色",
    "1563": "SPU名称",
    "1564": "可用库存",
    "1565": "原成交单价",
    "1566": "服务费",
    "1567": "下单店铺不允许为空，请选择下单店铺！",
    "1568": "请选择要删除的明细！",
    "1569": "收货人地址格式不正确,",
    "1570": "街道/乡镇",
    "1571": "邮编",
    "1572": "请选择需要更换商品记录！",
    "1573": "只能选择一条商品记录！",
    "1574": "派件",
    "1575": "揽收",
    "1576": "退回",
    "1577": "退签",
    "1578": "转投",
    "1579": "疑难",
    "1580": "清关",
    "1581": "拒签",
    "1582": "传WMS成功",
    "1583": "未虚拟入库",
    "1584": "虚拟入库已入库",
    "1585": "平台退款单号:",
    "1586": "退单时间:",
    "1587": "收货人邮编",
    "1588": "终止入库数量",
    "1589": "平台退货金额",
    "1590": "单件换货金额",
    "1591": "等待入库确认",
    "1592": "退货单",
    "1593": "批量修改地址",
    "1594": "财",
    "1595": "订单无需财审！",
    "1596": "请选择需要反审核并卡单的记录！",
    "1597": "请选择需要的记录！",
    "1598": "待审核",
    "1599": "订单状态不是【待审核】，不允许重新寻物流！",
    "1600": "最多可勾选20条单据！",
    "1601": "选择的订单中存在JITX订单, 不允许添加赠品！",
    "1602": "退换货单新增",
    "1603": "工单",
    "1604": "复制订单",
    "1605": "重新分配快递",
    "1606": "重新分配仓库",
    "1607": "请选择需要拆单的单据记录！",
    "1608": "您勾选的订单业务类型不正确或者状态不符合要求",
    "1609": "您选择的订单不是周期购订单，不允许修改！",
    "1610": "请选择需要修改的记录！",
    "1611": "不允许批量修改预计发货时间！",
    "1612": "标签",
    "1613": "申请发票",
    "1614": "反审核",
    "1615": "多包裹",
    "1616": "卡",
    "1617": "异常",
    "1618": "复",
    "1619": "补",
    "1620": "预",
    "1621": "合",
    "1622": "出库通知单单号的id为空",
    "1623": "未通知",
    "1624": "通知中",
    "1625": "已通知",
    "1626": "取消中",
    "1627": "取消失败",
    "1628": "有效订单",
    "1629": "拆单原因",
    "1630": "预售类型",
    "1631": "请选择需要打标的订单记录！",
    "1632": "系统作废",
    "1633": "状态已取消或作废，不能打标！",
    "1634": "自定义订单标签",
    "1635": "查询无结果，请隔段时间再查",
    "1636": "当前物流单号还未有物流轨迹信息，请稍后再查！",
    "1637": "请谨慎操作，执行后会影响WMS的在途库存数量！是否确认继续执行？",
    "1638": "是否确认操作SIGN转ADD？",
    "1639": "订单只能是原单才能补发！",
    "1640": "非已取消或系统作废订单，不允许补发！",
    "1641": "只能对【仓库发货，平台发货】订单状态的原单进行补发操作！",
    "1642": "【仓库发货、平台发货、取消/作废】的单据，不允许执行【审核】操作！",
    "1643": "信息",
    "1644": "审核当前勾选订单",
    "1645": "合并订单并审核",
    "1646": "请选择需要强制审核的记录！",
    "1647": "【仓库发货、平台发货、取消/作废】的单据，不允许执行【反审核】操作！",
    "1648": "货到付款",
    "1649": "非预售",
    "1650": "预售尾款已付",
    "1651": "合并订单",
    "1652": "取消合并订单",
    "1653": "时间",
    "1654": "操作",
    "1655": "只允许仓库发货、平台发货状态订单批量退单",
    "1656": "请输入拆单原因",
    "1657": "请选择需要修改的单据记录！",
    "1658": "确定执行订单业务类型修改？",
    "1659": "请选择需要卡单的数据",
    "1660": "搜索",
    "1661": "关闭",
    "1662": "条码",
    "1663": "是否赠品",
    "1664": "国标码",
    "1665": "销售价",
    "1666": "是否可拆单",
    "1667": "不可售",
    "1668": "库存数",
    "1669": "当前展示的库存数为订单的店铺和实体关联的逻辑仓下良品仓的可用库存数量汇总",
    "1670": "拆分数量只能为正整数",
    "1671": "未查询到数据",
    "1672": "单据来源",
    "1673": "手动",
    "1674": "单据日期",
    "1675": "平台状态",
    "1676": "业务类型",
    "1677": "业务单据",
    "1678": "平台商品编码",
    "1679": "规格名称",
    "1680": "可退金额",
    "1681": "已发货退款单",
    "1682": "日志明细请求失败",
    "1683": "平台赠品",
    "1684": "系统赠品",
    "1685": "退款原因",
    "1686": "判责方",
    "1687": "退款金额",
    "1688": "确定原始订单编号::",
    "1689": "保存出错",
    "1690": "原始订单编号",
    "1691": "判责方备注",
    "1692": "自动",
    "1693": "发货单",
    "1694": "买家昵称",
    "1695": "买家手机号",
    "1696": "原始平台单号",
    "1697": "支付账号",
    "1698": "赠品",
    "1699": "成交金额",
    "1700": "购买数量",
    "1701": "可退数量",
    "1702": "普通商品",
    "1703": "预售商品",
    "1704": "未拆分的组合商品",
    "1705": "轻供商品",
    "1706": "其它",
    "1707": "用户名称",
    "1708": "创建人姓名",
    "1709": "同意退款",
    "1710": "退款完成",
    "1711": "拒绝退款",
    "1712": "确认",
    "1713": "选择退款单据",
    "1714": "收款方账号",
    "1715": "打款失败原因",
    "1716": "中台业务类型",
    "1717": "请先选中一条要操作的单据！",
    "1718": "当前选中的单据明细行为空 或 明细行中的\")可退金额(RETURNABLE_AMOUNT)t(\"等于0，请重新选择！",
    "1719": "图片凭证最多添加10张图片",
    "1720": "请先选择退款单据！",
    "1721": "请选择要退款的明细！",
    "1722": "平台退款状态",
    "1723": "平台退款原因",
    "1724": "平台退款说明",
    "1725": "生成退单",
    "1726": "原始单据编号",
    "1727": "条码编码",
    "1728": "商品编码",
    "1729": "请选择生成退单的订单明细",
    "1730": "明细退款金额不能为空",
    "1731": "明细退款金额总和与总退款金额不一致",
    "1732": "退款原因请求失败",
    "1733": "批量导入",
    "1734": "提前换货",
    "1735": "换货转退货",
    "1736": "从WMS撤回",
    "1737": "门店一键入库",
    "1738": "同步通用平台状态",
    "1739": "是否确定同步通用平台状态？",
    "1740": "终止入库",
    "1741": "待确认",
    "1742": "待传WMS",
    "1743": "待退货入库",
    "1744": "未传WMS",
    "1745": "WMS撤回",
    "1746": "入库确认",
    "1747": "重传WMS",
    "1748": "无需传",
    "1749": "待传",
    "1750": "传成功",
    "1751": "传失败",
    "1752": "线下处理完成",
    "1753": "退单ID",
    "1754": "等待退货入库",
    "1755": "已揽收",
    "1756": "请选中一项确认!",
    "1757": "退换货单没有物流单号，是否确认？",
    "1758": "只有等待入库确认状态的退单可以入库确认，请重新选择数据！",
    "1759": "是否确定入库确认？",
    "1760": "入库确认成功",
    "1761": "此退换货单已生成未作废的换货类型零售发货单,不允许取消,继续将作废换货类型零售发货单以及退换订单",
    "1762": "未确认",
    "1763": "只有“确认状态”为未确认，才可以修改!",
    "1764": "WMS手动撤回失败！",
    "1765": "单据未全部入库，是否执行强制完成？",
    "1766": "是否确定批量申请补充物流信息",
    "1767": "只有“确认状态”为未确认，才能进行退转换操作",
    "1768": "转换失败",
    "1769": "平台信息",
    "1770": "查询物流轨迹",
    "1771": "补寄",
    "1772": "预留库存",
    "1773": "勾选后，退换货单保存成功后会生成零售发货单并寻源占库存，不勾选则会待仓库入库完成后才生成零售发货单",
    "1774": "原单买家备注",
    "1775": "原单卖家备注",
    "1776": "传奶卡状态",
    "1777": "是否错发",
    "1778": "质检状态",
    "1779": "未通过",
    "1780": "通过",
    "1781": "确认状态",
    "1782": "确认人",
    "1783": "确认时间",
    "1784": "虚拟入库状态",
    "1785": "入库时间",
    "1786": "终止状态",
    "1787": "部分",
    "1788": "终止入库时间",
    "1789": "入库确认人",
    "1790": "入库确认时间",
    "1791": "传AG状态",
    "1792": "WMS单据编号",
    "1793": "传WMS状态",
    "1794": "WMS撤回状态",
    "1795": "传WMS失败次数",
    "1796": "传WMS失败原因",
    "1797": "收货人省",
    "1798": "收货人街道",
    "1799": "实物商品",
    "1800": "SN信息",
    "1801": "一键入库",
    "1802": "换货人信息解密",
    "1803": "申请数量不允许大于可退数量!",
    "1804": "终止数量",
    "1805": "错发条码",
    "1806": "未查询到条码!",
    "1807": "不允许出现条码一致的明细!",
    "1808": "店铺名称不允许为空，请选择下单店铺！",
    "1809": "请输入sku、款号",
    "1810": "等待退货入库且传WMS成功状态的单据不可修改！",
    "1811": "取消状态单据无法修改!",
    "1812": "原始单据编号不能为空!",
    "1813": "退回物流公司 及 退回物流公司ID（CP_C_LOGISTICS_ID）不能为空！",
    "1814": "退款原因不能为空",
    "1815": "退回物流单号不能为空",
    "1816": "入库实体仓库不能为空",
    "1817": "无次品调拨",
    "1818": "次品已调拨",
    "1819": "次品未调拨",
    "1820": "退货明细存在申请数量为0的数据，不能保存，请检查处理！",
    "1821": "退货明细存在申请数量为负的数据，不能保存，请检查处理！",
    "1822": "退货明细颜色不能为空",
    "1823": "退货明细尺码不能为空",
    "1824": "在“单据类型=退货”且“退款原因=发错货”时，“是否错发”强制开启，且“错发条码”必填，且不能跟原SKU编码一样！",
    "1825": "换货明细颜色不能为空",
    "1826": "换货明细尺码不能为空",
    "1827": "请输入SN码！",
    "1828": "未拣货数量",
    "1829": "通知数",
    "1830": "已拣货数",
    "1831": "箱号",
    "1832": "清空",
    "1833": "已审核订单不允许清空",
    "1834": "已作废订单不允许清空",
    "1835": "查看未扫描商品",
    "1836": "是否箱",
    "1837": "扫描数量",
    "1838": "配码",
    "1839": "尺寸",
    "1840": "吊牌价",
    "1841": "通知数量",
    "1842": "已拣货数量",
    "1843": "出库通知单号",
    "1844": "拣货箱号",
    "1845": "装箱数量",
    "1846": "出库结果单号",
    "1847": "发货方",
    "1848": "收货方",
    "1849": "审核人",
    "1850": "审核时间",
    "1851": "最后一箱，不允许删除!",
    "1852": "已审核订单不允许修改",
    "1853": "已作废订单不允许修改",
    "1854": "商品不能为空!",
    "1855": "扫描数量不能为空!",
    "1856": "明细不存在!",
    "1857": "当前单据未保存,不允许审核!",
    "1858": "入库通知单号",
    "1859": "入库结果单号",
    "1860": "明细不存在",
    "1861": "发出条码",
    "1862": "发出条码不能为空",
    "1863": "SKU编码",
    "1864": "条形码",
    "1865": "退回物流公司",
    "1866": "退回物流单号",
    "1867": "提货人",
    "1868": "提货人手机",
    "1869": "拒单原因",
    "1870": "拒单原因说明",
    "1871": "营业员工号",
    "1872": "营业员姓名",
    "1873": "最晚发货时间",
    "1874": "预计送达时间",
    "1875": "电子面单状态",
    "1876": "获取电子面单失败原因",
    "1877": "取消电子面单失败原因",
    "1878": "收货人电话",
    "1879": "区",
    "1880": "详细地址",
    "1881": "配送方式",
    "1882": "物流单号",
    "1883": "是否通知发货方入库",
    "1884": "发货方入库状态",
    "1885": "商品名称",
    "1886": "完整",
    "1887": "不完整",
    "1888": "规格属性",
    "1889": "商品信息完整度",
    "1890": "是否需要发布",
    "1891": "发布状态",
    "1892": "发布成功/失败时间",
    "1893": "失败原因/备注",
    "1894": "发布时间",
    "1895": "发布失败原因",
    "1896": "分发",
    "1897": "请先选择需要修改的记录",
    "1898": "修改商品信息",
    "1899": "待发布",
    "1900": "发布成功",
    "1901": "发布失败",
    "1902": "部分失败",
    "1903": "部分待发",
    "1904": "部分待发&失败",
    "1905": "分发成功",
    "1906": "待分发",
    "1907": "分发失败",
    "1908": "赠品标记",
    "1909": "规格3",
    "1910": "成交单价",
    "1911": "零售发货单单号",
    "1912": "申请退货数量",
    "1913": "退货单价",
    "1914": "退货金额",
    "1915": "换货数量",
    "1916": "请勾选ID",
    "1917": "只能勾选单个ID",
    "1918": "订单已审核，不允许添加赠品记录，建议反审核再进行修改！",
    "1919": "当前状态异常，不允许添加赠品！",
    "1920": "该订单为JITX订单, 不允许添加赠品！",
    "1921": "标记退款完成",
    "1922": "标记取消退款",
    "1923": "当前订单状态不允许明细备注！",
    "1924": "只能选择一条修改备注的记录！",
    "1925": "赠品拆单方式",
    "1926": "效期类型",
    "1927": "生产日期范围",
    "1928": "生产天数范围",
    "1929": "生产日期和数量",
    "1930": "效期范围",
    "1931": "商品规格",
    "1932": "商品重量(KG)",
    "1933": "商品总重量(KG)",
    "1934": "性别",
    "1935": "缺货数量",
    "1936": "实物报缺",
    "1937": "赠品挂靠关系",
    "1938": "赠品类型",
    "1939": "价格",
    "1940": "平台售价",
    "1941": "结算单价",
    "1942": "结算金额",
    "1943": "商品优惠分摊",
    "1944": "调整金额",
    "1945": "平台补贴金额",
    "1946": "订单优惠分摊",
    "1947": "实付金额",
    "1948": "购物金核销子订单权益金分摊金额",
    "1949": "购物金核销子订单本金分摊金额",
    "1950": "取消状态",
    "1951": "买家已经申请退款，等待卖家同意",
    "1952": "卖家已经同意退款，等待买家退货",
    "1953": "买家已经退货，等待卖家确认收货",
    "1954": "卖家拒绝退款",
    "1955": "退款关闭",
    "1956": "退款成功",
    "1957": "分销金额",
    "1958": "直播来源",
    "1959": "直播主体",
    "1960": "配合主体",
    "1961": "直播场次",
    "1962": "促销编码",
    "1963": "子订单编号",
    "1964": "预计发货时间",
    "1965": "赠品发货节点",
    "1966": "赠品发货间隔时长(小时)",
    "1967": "促销活动名称",
    "1968": "促销活动编码",
    "1969": "直播相关信息",
    "1970": "主播名称",
    "1971": "其它扩展信息",
    "1972": "购物金本金分摊金额",
    "1973": "购物金权益金分摊金额",
    "1974": "此商品中不存在该规格",
    "1975": "订单ID",
    "1976": "单据编号:",
    "1977": "合并平台单号:",
    "1978": "平台订单名称",
    "1979": "交易平台",
    "1980": "预售尾款未付",
    "1981": "是否传SAP:",
    "1982": "传SAP状态:",
    "1983": "打包状态:",
    "1984": "未打包",
    "1985": "已打包",
    "1986": "是否打印礼品卡:",
    "1987": "礼品收送人:",
    "1988": "礼品发送人:",
    "1989": "礼品卡内容:",
    "1990": "会员编码:",
    "1991": "预计发货时间:",
    "1992": "业务类型:",
    "1993": "订单来源系统:",
    "1994": "交易来源平台单号:",
    "1995": "原单店铺:",
    "1996": "期数:",
    "1997": "异常订单",
    "1998": "待寻源",
    "1999": "已确认收货",
    "2000": "交易完成",
    "2001": "预售待发货",
    "2002": "预售缺货",
    "2003": "退单编号查询",
    "2004": "退换货单号",
    "2005": "原单单号",
    "2006": "收货人手机号",
    "2007": "实体仓库",
    "2008": "是否手工新增",
    "2009": "退货批次",
    "2010": "入库仓库",
    "2011": "手机号",
    "2012": "姓名",
    "2013": "特殊处理类型",
    "2014": "发件地址",
    "2015": "退单编号",
    "2016": "此明细已经匹配，不允许修改退换货单号！",
    "2017": "入库单商品明细",
    "2018": "退货入库日志",
    "2019": "实收条码",
    "2020": "商品标记",
    "2021": "是否匹配",
    "2022": "是否生成调整单",
    "2023": "是否无原单条码",
    "2024": "实际发出条码",
    "2025": "处理人",
    "2026": "处理人备注",
    "2027": "入库单单号",
    "2028": "退货批次必填！",
    "2029": "特殊处理类型必填！",
    "2030": "请输入查询条件！",
    "2031": "请选择一条数据！",
    "2032": "批量接单",
    "2033": "去拣货",
    "2034": "批量呼叫快递",
    "2035": "批量发货",
    "2036": "批量导出",
    "2037": "交接给物流",
    "2038": "接单",
    "2039": "呼叫快递",
    "2040": "拒单",
    "2041": "查看包裹详情",
    "2042": "装箱复核",
    "2043": "打印装箱单",
    "2044": "发货",
    "2045": "核销",
    "2046": "拒单处理",
    "2047": "核销处理",
    "2048": "待接单",
    "2049": "已发货",
    "2050": "拣货中",
    "2051": "已拣货",
    "2052": "全部复核",
    "2053": "部分复核",
    "2054": "单据已呼叫过快递，不允许重复呼叫",
    "2055": "单据已接单，不允许重复接单",
    "2056": "发货处理",
    "2057": "您需要勾选单据状态不是“待发货”或者没有接单！",
    "2058": "打印拣货单",
    "2059": "打印交接单",
    "2060": "平台店铺昵称",
    "2061": "售后类型",
    "2062": "售后申请日期",
    "2063": "售后原因",
    "2064": "售后原因说明",
    "2065": "请输入收货人",
    "2066": "请输入收货人手机",
    "2067": "请选择收货人省份",
    "2068": "请选择收货人市",
    "2069": "请选择收货人区",
    "2070": "请输入收货人地址",
    "2071": "申请数量",
    "2072": "申请数量不能大于可退数量！",
    "2073": "单件退款金额",
    "2074": "换货平台条码ID",
    "2075": "请选择售后类型",
    "2076": "请勾选订单明细",
    "2077": "勾选订单明细的换货平台条码ID不能为空",
    "2078": "勾选订单明细的申请数量必填，且不能大于可退数量",
    "2079": "对等换货策略",
    "2080": "请选中一条单据！",
    "2081": "确认执行",
    "2082": "销售数量",
    "2083": "换货商品",
    "2084": "换货商品名称",
    "2085": "对等商品",
    "2086": "对等商品名称",
    "2087": "对等数量",
    "2088": "请填写物流单号！",
    "2089": "标记管理",
    "2090": "标记说明",
    "2091": "不可超过6个汉字",
    "2092": "请选择需要添加的标记!",
    "2093": "请选择需要取消的标记",
    "2094": "标记说明不能为空!",
    "2095": "复制原因",
    "2096": "丢件复制",
    "2097": "错漏发复制",
    "2098": "赠品复制",
    "2099": "请选择复制原因！",
    "2100": "换吊牌后条码",
    "2101": "请选择打标的标签",
    "2102": "请选择需要取消的标签",
    "2103": "请选择要操作的标签！",
    "2104": "请输入正确的预计发货时间！",
    "2105": "预计到货时间",
    "2106": "补差单号",
    "2107": "请录入OM单号并回车！",
    "2108": "补差金额",
    "2109": "补发订单编号",
    "2110": "请录入OM单号并回车!",
    "2111": "修改物流单号",
    "2112": "请选择预计发货时间！",
    "2113": "修改传WMS拣货单字段",
    "2114": "选择导入模板",
    "2115": "选择导入页签",
    "2116": "请选择导入模板",
    "2117": "请选择导入页签",
    "2118": "请选择选择导入模板或导入页签",
    "2119": "请选择需要修改店铺的单据记录！",
    "2120": "单据已转入，不能修改！",
    "2121": "请选择店铺！",
    "2122": "只支持【退款失败】的额外退款单单据进行退款失败处理！",
    "2123": "流水号",
    "2124": "请输入流水号！",
    "2125": "预计发货时间不能为空！",
    "2126": "预计发货时间不能小于当前时间！",
    "2127": "预览",
    "2128": "上传",
    "2129": "送礼人姓名",
    "2130": "请输入送礼人名称",
    "2131": "收礼人姓名",
    "2132": "请输入收礼人名称",
    "2133": "赠言",
    "2134": "请输入赠言",
    "2135": "礼品卡图片",
    "2136": "卡类型",
    "2137": "卡号",
    "2138": "异常商品",
    "2139": "替换异常商品",
    "2140": "当前记录已审核，不允许替换商品明细！",
    "2141": "当前记录已不存在！",
    "2142": "请先选择需要替换商品的记录！",
    "2143": "选择的商品包含正常商品，是否确认要替换！",
    "2144": "是否确定导出选中的主子表数据?",
    "2145": "收货人城市:",
    "2146": "商品编号",
    "2147": "生产月份",
    "2148": "生产日期",
    "2149": "可用量",
    "2150": "在库量",
    "2151": "占用量",
    "2152": "冻结量",
    "2153": "在途量",
    "2154": "来源单类型",
    "2155": "逻辑占用单据编号",
    "2156": "占用数量",
    "2157": "占用库存",
    "2158": "差异量",
    "2159": "到货天数",
    "2160": "零担费用",
    "2161": "调拨费用",
    "2162": "总费用",
    "2163": "逻辑占用单号",
    "2164": "收货人城市",
    "2165": "占单结果查询",
    "2166": "逻辑占用明细",
    "2167": "物流或仓库不能为空",
    "2168": "重新占单",
    "2169": "暂无可提交数据",
    "2170": "生产日期不可为空！",
    "2171": "占用数量不可为空！",
    "2172": "非赠品",
    "2173": "是否组合下挂",
    "2174": "实际退货数量",
    "2175": "申请退款金额",
    "2176": "请选择至少一条明细！",
    "2177": "关联原单",
    "2178": "发货状态",
    "2179": "未发货",
    "2180": "部分发货",
    "2181": "全部发货",
    "2182": "订单信息",
    "2183": "收货人信息",
    "2184": "配货信息",
    "2185": "支付信息",
    "2186": "顾客拒收后发货方入库信息",
    "2187": "买家下单",
    "2188": "买家付款",
    "2189": "商品出库",
    "2190": "买家确认收货",
    "2191": "通知发货方入库",
    "2192": "图片",
    "2193": "支付金额",
    "2194": "全渠道订单",
    "2195": "总扫描数量",
    "2196": "选择入库的物流包裹",
    "2197": "物流单号不一致不允许合并入库，选择其中一个包裹入库",
    "2198": "入库",
    "2199": "扫描单号",
    "2200": "支持物流单号、平台单号",
    "2201": "删除",
    "2202": "残次",
    "2203": "已入库数量",
    "2204": "商品信息",
    "2205": "错发商品",
    "2206": "清空当前未完成单据继续扫描下一张单据？",
    "2207": "请扫描单号查询",
    "2208": "是否清空当前未完成单据继续扫描下一张单据？",
    "2209": "未找到退货单据，请联系店铺客服",
    "2210": "请输入商品SKU",
    "2211": "您扫描的商品不在退货单中！",
    "2212": "物流单号为空，不允许入库",
    "2213": "商品为空，不允许入库",
    "2214": "商品未扫描，不允许入库",
    "2215": "是否确认执行入库？",
    "2216": "请选择单据",
    "2217": "物流单号不一致",
    "2218": "退单信息",
    "2219": "退单物流信息",
    "2220": "明细",
    "2221": "提交申请",
    "2222": "待收货",
    "2223": "已收货",
    "2224": "全渠道退货扫描单",
    "2225": "扫描商品",
    "2226": "全渠道退货单",
    "2227": "请选择单据！",
    "2228": "是否确认取消快递单号？",
    "2229": "包裹详情",
    "2230": "包",
    "2231": "裹",
    "2232": "单据编号(OM)",
    "2233": "已拒单",
    "2234": "拒单时间",
    "2235": "配送信息",
    "2236": "发货操作",
    "2237": "系统将生成物流交接单，是否确定？",
    "2238": "请输入营业员工号",
    "2239": "确定并打印交接单",
    "2240": "接单状态",
    "2241": "已接单",
    "2242": "接单时间",
    "2243": "发货时间",
    "2244": "该包裹物流单号为空，不允许打印！",
    "2245": "包裹信息维护",
    "2246": "拣",
    "2247": "退",
    "2248": "收起",
    "2249": "展开",
    "2250": "待提货",
    "2251": "已提货",
    "2252": "核销时间",
    "2253": "请输入查询条件进行搜索",
    "2254": "收货人手机格式不正确！",
    "2255": "当前选中行没有物流单号！",
    "2256": "寻源日志",
    "2257": "仓库可用量",
    "2258": "分仓结果",
    "2259": "寻源过程",
    "2260": "寻源占单详情",
    "2261": "寻源详情",
    "2262": "寻源占单",
    "2263": "修改地址",
    "2264": "指定数量",
    "2265": "开始生产日期/天数",
    "2266": "结束生产日期/天数",
    "2267": "【指定数量】只能为正整数！",
    "2268": "复制收货信息",
    "2269": "修改",
    "2270": "物流轨迹",
    "2271": "收件人信息",
    "2272": "功能按钮",
    "2273": "支持上下拖拽排序",
    "2274": "最多显示50个筛选条件",
    "2275": "订单明细导入",
    "2276": "运费",
    "2277": "智能匹配地址",
    "2278": "如:张三,17788888888,上海上海市闵行区黎安路999号（输入后请按Enter键）",
    "2279": "电话",
    "2280": "在线支付",
    "2281": "存在超长录入！",
    "2282": "卖家备注超长！",
    "2283": "收货人超长！",
    "2284": "收货人电话超长！",
    "2285": "收货人邮编超长！",
    "2286": "订单明细不能为空！",
    "2287": "组合",
    "2288": "批量拆单-按行拆单",
    "2289": "批量拆单-一单一货",
    "2290": "查库存",
    "2291": "非批量时，仅展示对应平台下的店铺",
    "2292": "上下架状态",
    "2293": "上架",
    "2294": "下架",
    "2295": "零售价必填",
    "2296": "商城商品名称",
    "2297": "原商城商品名称",
    "2298": "新商城商品名称",
    "2299": "原平台类目",
    "2300": "新平台类目",
    "2301": "请选择平台类目！",
    "2302": "请输入商城商品名称！",
    "2303": "商品将被",
    "2304": "是否确认？",
    "2305": "请先选择需要通知发货的记录",
    "2306": "修改零售价",
    "2307": "下架原因",
    "2308": "请填写下架原因",
    "2309": "星期一",
    "2310": "请先填写正确的周指标或者周指标调整",
    "2311": "周指标之和不等于计划销售指标",
    "2312": "周指标调整之和不等于计划销售指标",
    "2313": "日指标之和不等于计划销售指标",
    "2314": "合单平台单号",
    "2315": "请选择平台单号",
    "2316": "当前礼品卡信息，是否确认？",
    "2317": "请选择平台单号！",
    "2318": "HOLD单",
    "2319": "订单卡单",
    "2320": "退货与退款",
    "2321": "重新寻源",
    "2322": "请选择退货明细！",
    "2323": "退货明细",
    "2324": "换货明细",
    "2325": "换货预留库存",
    "2326": "登录界面背景图",
    "2327": "登录界面LOGO",
    "2328": "门店档案",
    "2329": "门店",
    "2330": "背景图设置表",
    "2331": "请选择门店",
    "2332": "请填写备注",
    "2333": "请选择登录界面背景图",
    "2334": "上传图片",
    "2335": "最多添加10张图片",
    "2336": "支持图片格式",
    "2337": "上传文件只能是jpg、png、gif、jpeg格式!",
    "2338": "图片凭证",
    "2339": "商品应退总金额",
    "2340": "应退邮费",
    "2341": "换货|补发总金额",
    "2342": "退款总金额",
    "2343": "平台退款总金额",
    "2344": "勾选【退货明细】后将自动添加至【换货明细】",
    "2345": "扫描出库",
    "2346": "扫描作业",
    "2347": "商品扫描",
    "2348": "扫描",
    "2349": "反冲",
    "2350": "部分出库",
    "2351": "作业实时动态",
    "2352": "总数",
    "2353": "未扫描数",
    "2354": "已扫描数",
    "2355": "已装箱数",
    "2356": "新增箱",
    "2357": "拣货明细",
    "2358": "来源出库通知单",
    "2359": "装箱明细",
    "2360": "来源出库结果单",
    "2361": "日志信息",
    "2362": "未扫描商品",
    "2363": "确认执行删除箱?",
    "2364": "确认清空?",
    "2365": "返回将不会保留你修改的内容,确定返回吗?",
    "2366": "错误提示",
    "2367": "您的浏览器不支持 audio 与元素。",
    "2368": "来源入库通知单",
    "2369": "来源入库结果单",
    "2370": "优先展示根据平台单号匹配的待入库的退单，当匹配不到退单时展示匹配的可退的订单",
    "2371": "当单据数据来源为退单时，物流单号不一致不允许合并入库",
    "2372": "单据数据来源",
    "2373": "选择入库单据",
    "2374": "请选择入库单据",
    "2375": "退单明细",
    "2376": "退货备注",
    "2377": "订单和退单均匹配不到时可通过选择订单退",
    "2378": "入库单信息",
    "2379": "扫描明细",
    "2380": "扫描区域",
    "2381": "自动匹配扫描数量",
    "2382": "客户姓名",
    "2383": "扫描人员",
    "2384": "机损",
    "2385": "箱损",
    "2386": "在途库存",
    "2387": "按选择明细退",
    "2388": "全部明细退",
    "2389": "未找到单据，可扫描商品SKU后进行无名件入库或者通过选择订单进行入库",
    "2390": "入库成功",
    "2391": "请选择需要入库的订单明细",
    "2392": "请输入查询内容",
    "2393": "通知仓库",
    "2394": "是否确认切换通知仓库，该操作将丢失未保存的数据！",
    "2395": "通知类型",
    "2396": "由业务参数默认带出",
    "2397": "是否确认切换通知类型，该操作将丢失未保存的数据！",
    "2398": "商品代码",
    "2399": "已通知数",
    "2400": "未通知数",
    "2401": "已配未发数",
    "2402": "已配已发数",
    "2403": "未配货数",
    "2404": "本次通知数",
    "2405": "不可大于本次未通知数！",
    "2406": "不可大于本次未配货数！",
    "2407": "已入库数",
    "2408": "未入库数",
    "2409": "请选择要通知入库的指定商品！",
    "2410": "是否确认通知入库？",
    "2411": "不可大于本次未入库数！",
    "2412": "选择模板",
    "2413": "文件生成成功！",
    "2414": "去预览/打印/下载",
    "2415": "请选择打印模板！",
    "2416": "选择物流公司",
    "2417": "获取单号数量",
    "2418": "请维护物流公司!",
    "2419": "包材类型",
    "2420": "已选中包材",
    "2421": "提货码",
    "2422": "选择包材",
    "2423": "选择冻结库存条码",
    "2424": "请维护拒单原因",
    "2425": "请维护选择冻结库存条码",
    "2426": "总件数",
    "2427": "待复核数",
    "2428": "已复核数",
    "2429": "购买明细",
    "2430": "未复核",
    "2431": "复核完毕",
    "2432": "购买数",
    "2433": "商品扫描区",
    "2434": "包裹列表",
    "2435": "请扫描国标码",
    "2436": "请输入国标码",
    "2437": "确定并打印装箱单",
    "2438": "添加到包裹列表",
    "2439": "商品货号",
    "2440": "该商品已复核完成！",
    "2441": "请输入包材",
    "2442": "请扫描商品条码",
    "2443": "请扫描商品并添加包裹",
    "2444": "请全部复核后，确认并打印装箱单",
    "2445": "请全部复核后再确认",
    "2446": "请选择物流公司",
    "2447": "包裹数与申请的物流单号数不一致，请确认！",
    "2448": "只有订单是待审核或缺货的才能操作",
    "2449": "取消商品",
    "2450": "行颜色填充为",
    "2451": "缺货商品",
    "2452": "成交总额",
    "2453": "用卡订单使用的本金",
    "2454": "用卡订单使用的权益金",
    "2455": "备注信息",
    "2456": "下载图片",
    "2457": "请输入折扣",
    "2458": "请输入价格",
    "2459": "收货店仓︰",
    "2460": "矩阵录入",
    "2461": "彩色区为发货店仓库存情况",
    "2462": "退换货订单明细",
    "2463": "查询原始订单编号",
    "2464": "无赠品可添加！",
    "2465": "发货实体仓",
    "2466": "承运商",
    "2467": "自动释放",
    "2468": "释放时点",
    "2469": "指定时点释放",
    "2470": "固定时长后释放",
    "2471": "分钟",
    "2472": "小时",
    "2473": "天",
    "2474": "指定时点释放的时间不能为空",
    "2475": "指定时点释放的时间不能小于当前时间",
    "2476": "固定时长后释放的固定时长只能是整数",
    "2477": "固定时长后释放的相关数据不能为空",
    "2478": "释放时点不能为空",
    "2479": "商品SKU名称",
    "2480": "sku查询失败",
    "2481": "替换前商品sku不能为空",
    "2482": "替换后商品sku码不能为空",
    "2483": "替换商品与被替换商品不能相同",
    "2484": "请勾选订单数据",
    "2485": "日程归属名称",
    "2486": "档案日程归属不能为空！",
    "2487": "出仓单",
    "2488": "请先选择一条数据更换吊牌！",
    "2489": "非【缺货】状态，不能进行换吊牌操作！",
    "2490": "JIT配货单换吊牌",
    "2491": "至少选择一条订单明细",
    "2492": "请选中其中一条记录",
    "2493": "请选中一条记录",
    "2494": "库存",
    "2495": "结算总额",
    "2496": "优惠金额",
    "2497": "平摊金额",
    "2498": "退款状态",
    "2499": "HOLD单原因",
    "2500": "直播HOLD单",
    "2501": "HOLD单原因不能为空",
    "2502": "档期日程归属",
    "2503": "日程归属",
    "2504": "识别号",
    "2505": "公司地址",
    "2506": "开户行账号",
    "2507": "收票地址",
    "2508": "发票抬头不能为空",
    "2509": "专用发票",
    "2510": "识别号不能为空",
    "2511": "公司地址不能为空",
    "2512": "电话号码不能为空",
    "2513": "开户银行不能为空",
    "2514": "开户行账号不能为空",
    "2515": "保存未成功",
    "2516": "押金订单号",
    "2517": "查询",
    "2518": "卖家昵称",
    "2519": "会员加急发货打标成功",
    "2520": "请选择物流单号",
    "2521": "快递名称",
    "2522": "快递编码",
    "2523": "简称",
    "2524": "请输入物流单号！",
    "2525": "请输入传WMS拣货单字段！",
    "2526": "查询数据为空",
    "2527": "请选中订单数据",
    "2528": "请选中需要新增的赠品",
    "2529": "sku不能为空！",
    "2530": "请填写收货人手机",
    "2531": "请填写收货人名称",
    "2532": "请填写省份！",
    "2533": "请填写城市！",
    "2534": "请填写详细地址！",
    "2535": "收货人手机不合法",
    "2536": "收货人电话不合法",
    "2537": "邮编不合法",
    "2538": "请正确填写省份",
    "2539": "请正确填写城市",
    "2540": "请正确填写区县",
    "2541": "省份查询失败",
    "2542": "请先选择省份",
    "2543": "城市查询失败",
    "2544": "请先选择城市",
    "2545": "区县查询失败",
    "2546": "下载类型",
    "2547": "仅下载拣货单",
    "2548": "创建并下载拣货单",
    "2549": "拣货单类型",
    "2550": "普通",
    "2551": "补货单",
    "2552": "预调拨",
    "2553": "手工占单成功！",
    "2554": "合并占单成功！",
    "2555": "入库实体仓库必填！",
    "2556": "拒绝打款原因不能为空！",
    "2557": "配送物流",
    "2558": "是否开票",
    "2559": "内部备注",
    "2560": "请填入完整信息,如:张三,17788888888,上海上海市闵行区黎安路999号",
    "2561": "收货人区",
    "2562": "发货店仓，不能为空",
    "2563": "订单存在非赠品的成交金额为0， 是否确定保存订单？",
    "2564": "订单管理编辑",
    "2565": "明细保存失败！",
    "2566": "请输入条码！",
    "2567": "不存在该条码！",
    "2568": "省市区",
    "2569": "订单状态已审核，建议反审核再修改地址",
    "2570": "订单状态非未确认、缺货、已审核、配货中，不允许修改地址",
    "2571": "平台订单号",
    "2572": "收件人",
    "2573": "入库数量",
    "2574": "单件退货金额",
    "2575": "换货金额",
    "2576": "总计",
    "2577": "请选择需要历史单平台发货的记录！",
    "2578": "请选择需要取消加急的记录！",
    "2579": "是否确定取消加急？",
    "2580": "请选择需要额外退款的记录",
    "2581": "只能选择一条记录进行退款",
    "2582": "只有仓库发货或者平台发货的订单才能操作额外退款",
    "2583": "手工创建",
    "2584": "请确认订单是否冻结库存并重新寻源？",
    "2585": "请选择需要重新寻源的记录!",
    "2586": "开票通知",
    "2587": "请选择需要开票的订单",
    "2588": "请选择一条订单",
    "2589": "订单取消",
    "2590": "拆分订单",
    "2591": "拦截、退款中的订单不允许拆单！",
    "2592": "只允许拆分待审核和缺货状态的订单！",
    "2593": "新增退单",
    "2594": "缺货重新占单",
    "2595": "福袋缺货重新占单",
    "2596": "备注导入",
    "2597": "更改为平台发货",
    "2598": "批量改商品",
    "2599": "批量拆单",
    "2600": "选择的订单中存在非待审核订单, 不允许释放库存！",
    "2601": "请选择需要库存释放的订单！",
    "2602": "是否原退",
    "2603": "订单详情获取失败",
    "2604": "仓库发货",
    "2605": "平台发货",
    "2606": "请选择需要审核的记录！",
    "2607": "要合并的单据的付款方式只能为非货到付款",
    "2608": "要合并的单据的预售状态只能为非预售",
    "2609": "要合并的单据的发货仓库只能为非空",
    "2610": "合并订单成功",
    "2611": "合并订单失败",
    "2612": "当前状态异常，不允许操作！",
    "2613": "取消合并订单成功",
    "2614": "取消合并订单失败",
    "2615": "请选择需要卡单释放的数据",
    "2616": "请选择需要更换的商品！",
    "2617": "不可以选择更换当前商品！",
    "2618": "请填写筛选条件！",
    "2619": "添加到待拆单",
    "2620": "确认拆单",
    "2621": "当前操作未确认拆单，是否确认刷新？",
    "2622": "已是原始状态，不执行操作！",
    "2623": "可售数量",
    "2624": "待拆数量",
    "2625": "拆分数量",
    "2626": "拆分数量不能大于待拆数量；不进行拆单！",
    "2627": "发货仓库名称",
    "2628": "发货仓库编码",
    "2629": "请选择需要拆分的明细！",
    "2630": "拆分数量不能为0！",
    "2631": "没有可拆分的订单！",
    "2632": "请先选择拆单明细添加到待拆单，再进行拆单！",
    "2633": "订单总额",
    "2634": "退款分类",
    "2635": "退款描述",
    "2636": "收款人姓名",
    "2637": "额外退款",
    "2638": "退货数量",
    "2639": "实际退款金额",
    "2640": "查询不到数据！",
    "2641": "请输入正确的买家手机号",
    "2642": "原始订单编号不能为空！",
    "2643": "没有明细可新增",
    "2644": "至少保留一条明细,不允许全部删除！",
    "2645": "确定删除所选明细?",
    "2646": "退款描述请求失败",
    "2647": "亲，您好！您的订单号",
    "2648": "因为",
    "2649": "原因，给您申请",
    "2650": "元的额外退款，我们将会在 3 个工作日之内给您打到您",
    "2651": "中，请您注意查收！感谢您的惠顾，欢迎下次光临，祝您生活愉快！",
    "2652": "售后审核",
    "2653": "手动入库",
    "2654": "取消自动退款",
    "2655": "修改退回仓库",
    "2656": "修改物流公司",
    "2657": "批量原退",
    "2658": "强制完成",
    "2659": "退换货复制",
    "2660": "卖家备注导入",
    "2661": "异常信息",
    "2662": "修改退货仓库",
    "2663": "此退换单状态不允许扫描入库,请重新选择！",
    "2664": "当前选中行，无法使用此按钮！",
    "2665": "单据状态不符合审核条件，请重新选择",
    "2666": "售后审核失败！",
    "2667": "退换货取消失败,只有【等待退货入库】状态才可以操作取消，请检查后重试！",
    "2668": "换货订单的状态为配货中或已经发货,是否确认直接取消退货？",
    "2669": "取消失败！",
    "2670": "是否确定虚拟入库？",
    "2671": "取消自动退款失败！",
    "2672": "请至少选中一项修改",
    "2673": "批量原退失败！",
    "2674": "是否确定批量换货转退货",
    "2675": "只有等待退货入库状态可以从WMS撤回",
    "2676": "从wms撤回失败！",
    "2677": "重WMS失败！",
    "2678": "请选中一条单据进行复制！",
    "2679": "不允许批量处理！",
    "2680": "标记次品已调拨",
    "2681": "退换货订单",
    "2682": "换货平台单号",
    "2683": "退货",
    "2684": "退换货",
    "2685": "发货实体仓库",
    "2686": "是否生成换货单",
    "2687": "传DRP次数",
    "2688": "传DRP失败原因",
    "2689": "退货状态",
    "2690": "请先填入原订单信息",
    "2691": "省市区id获取失败",
    "2692": "换货邮费",
    "2693": "退货单日志",
    "2694": "次品记录",
    "2695": "次品调拨状态",
    "2696": "获取详情失败！",
    "2697": "传WMS成功状态的单据不可修改！",
    "2698": "只有等待退货入库和等待售后确认状态的单据 或 完成状态且虚拟入库未入库状态的单据可修改！",
    "2699": "省市信息必填！",
    "2700": "收货人姓名不合法，请重新填写！",
    "2701": "收货人必填！",
    "2702": "收货人手机必填！",
    "2703": "电话号码不合法，请重新填写！",
    "2704": "收货人地址必填！",
    "2705": "退货明细必须有行数据！",
    "2706": "换货明细必须有行数据！",
    "2707": "换货金额必须等于退货金额！",
    "2708": "退货总金额不能小于0，请修改后重新保存！",
    "2709": "请输入正确的换货邮费！",
    "2710": "退货明细数量不能为0！",
    "2711": "退货明细条码不能为空！",
    "2712": "换货明细换货数量不能为空",
    "2713": "换货明细条码不能为空",
    "2714": "可用库存查询失败",
    "2715": "新增退换货订单失败！",
    "2716": "强制完成失败！",
    "2717": "请选择一条需要删除的明细！",
    "2718": "不允许批量删除明细！",
    "2719": "原始平台单号存在多条记录，请用订单编号查询！",
    "2720": "未查询到数据！",
    "2721": "只能选择一条订单记录！",
    "2722": "收货方名称",
    "2723": "必须填写物流单号才能强制保存",
    "2724": "扫描数量不能为零！",
    "2725": "退货批次不能为空！",
    "2726": "强制入库失败",
    "2727": "销退入库仓",
    "2728": "手机号码",
    "2729": "退货入库单中存在此物流单号，不允许扫描入库！",
    "2730": "数据",
    "2731": "强制入库",
    "2732": "清除",
    "2733": "退换货备注",
    "2734": "收件人手机",
    "2735": "批次类型",
    "2736": "原发货仓",
    "2737": "实收国标码",
    "2738": "销退入库仓不能为空！",
    "2739": "是否自动匹配",
    "2740": "鞋盒条码与实物条码不符",
    "2741": "实收条码不能为空",
    "2742": "实收条码与发出条码一致，请检查后重新扫描",
    "2743": "本地条码档案中不存在此条码，请检查后重试",
    "2744": "请先选择一行记录进行扫描",
    "2745": "原平台单号",
    "2746": "联系电话",
    "2747": "发货地址",
    "2748": "请输入退单编号",
    "2749": "请输入手机号码",
    "2750": "买家昵称超长！",
    "2751": "退货人姓名超长！",
    "2752": "退货原因超长！",
    "2753": "退回运单号超长！",
    "2754": "单据备注超长！",
    "2755": "请选择一条需要替换的明细！",
    "2756": "请选择一条订单明细！",
    "2757": "只能一条订单明细！",
    "2758": "平台编号",
    "2759": "平台交易状态",
    "2760": "是否自提",
    "2761": "发货门店名称",
    "2762": "发货门店编码",
    "2763": "订单状态不满足，不允许修改地址！",
    "2764": "杭州店仓",
    "2765": "待分配",
    "2766": "配货中",
    "2767": "平台发货失败",
    "2768": "取消/作废",
    "2769": "待换货",
    "2770": "待确认-换货完成",
    "2771": "已签收",
    "2772": "手工匹配",
    "2773": "请选择一条明细手工匹配",
    "2774": "只能选择一条明细手工匹配",
    "2775": "状态不匹配不能进入手动匹配",
    "2776": "错发强制匹配",
    "2777": "请选择一条明细错发强制匹配",
    "2778": "只能选择一条明细错发强制匹配",
    "2779": "状态不匹配不能进入错发强制匹配",
    "2780": "作废操作成功",
    "2781": "作废操作失败",
    "2782": "是否关闭匹配",
    "2783": "是否生成入库单",
    "2784": "是否生成错发调整单",
    "2785": "是否生成冲无头件调整单",
    "2786": "退货入库明细不能为空！",
    "2787": "请勾选需要操作的单据！",
    "2788": "换货人信息",
    "2789": "添加标记",
    "2790": "买家HOLD单",
    "2791": "是否确定修改内部备注？",
    "2792": "被替换商品SKU",
    "2793": "替换后商品SKU",
    "2794": "将",
    "2795": "替换为",
    "2796": "旗帜",
    "2797": "当前备注:",
    "2798": "修改备注:",
    "2799": "是否确认修改备注！",
    "2800": "改仓原因",
    "2801": "原仓缺货改仓",
    "2802": "系统错判改仓",
    "2803": "新增仓库改仓",
    "2804": "运输方式",
    "2805": "唯品会入库单",
    "2806": "开票状态",
    "2807": "开专用发票必须跟开票专员确认",
    "2808": "当前操作会给订单打上加急发货【急】标识，请确认！",
    "2809": "收货信息",
    "2810": "新收货信息",
    "2811": "新地址",
    "2812": "平台地址",
    "2813": "新详细地址",
    "2814": "系统备注",
    "2815": "按页面已勾选订单",
    "2816": "按筛选条件选中订单",
    "2817": "强制匹配",
    "2818": "查询退单",
    "2819": "清除退单",
    "2820": "未做任何修改！",
    "2821": "失败信息！",
    "2822": "失败明细！",
    "2823": "已匹配退货单号，不允许清除！",
    "2824": "未匹配退换货单，不允许清除！",
    "2825": "存在明细已经匹配退货单，请重新进行选择！",
    "2826": "条码一致，请走手工匹配！",
    "2827": "没有匹配到退货单明细！",
    "2828": "失败序号",
    "2829": "失败SKU",
    "2830": "失败原因！",
    "2831": "匹配失败提示框",
    "2832": "清除失败提示框",
    "2833": "拒绝打款原因",
    "2834": "请输入拒绝打款原因",
    "2835": "单据备注",
    "2836": "原订单编号不能为空！",
    "2837": "订单收货地址",
    "2838": "切换为sku商品显示",
    "2839": "切换为平台商品明细",
    "2840": "商品优惠",
    "2841": "订单优惠",
    "2842": "将对查询出的订单数据重新分配快递，是否继续?",
    "2843": "将对查询出的订单数据重新分配仓库，是否继续?",
    "2844": "批量生成退换货订单，是否继续?",
    "2845": "是否确定反审核订单？",
    "2846": "取消拦截",
    "2847": "新增工单",
    "2848": "只允许仓库发货、平台发货状态订单允许新增退单！",
    "2849": "是否确定重新寻源？",
    "2850": "添加商品-已选",
    "2851": "替换明细",
    "2852": "删除退货商品！",
    "2853": "请确认是否删除当前选中的退货商品，还存在关联的挂靠赠品",
    "2854": "请确认是否删除当前选中的退货商品，还存在组合/福袋下挂的其他关联商品",
    "2855": "并且还存在组合/福袋下挂的其他关联商品",
    "2856": "请确认是否删除当前选中的退货商品？",
    "2857": "删除换货商品",
    "2858": "请确认是否删除当前选中的换货商品？",
    "2859": "请选择一条明细！",
    "2860": "商品应退金额",
    "2861": "应退运费",
    "2862": "最终应退总金额",
    "2863": "查询原平台单号",
    "2864": "输入后请按Enter",
    "2865": "没有查询到当前平台单号！",
    "2866": "退货明细不能为空！",
    "2867": "换货明细不能为空！",
    "2868": "最终应退总金额不能小于0！",
    "2869": "换货金额与退货金额不一致请重新确认！",
    "2870": "退换货单详情",
    "2871": "换货人信息请切换为明文！",
    "2872": "退换货单明细都不能为空！",
    "2873": "换货金额必须要和退货金额一致！",
    "2874": "退货单不能为空！",
    "2875": "退款又发货",
    "2876": "退款未入库",
    "2877": "退款后换货发货",
    "2878": "急速退款发货预警",
    "2879": "点击后将删除凭证,是否继续?",
    "2880": "退款类型",
    "2881": "仅退款",
    "2882": "退货退款",
    "2883": "退款单详情",
    "2884": "原始退单明细",
    "2885": "商品实退金额",
    "2886": "最终实退总金额",
    "2887": "新增退货明细",
    "2888": "扫描信息",
    "2889": "录入信息",
    "2890": "退换货信息",
    "2891": "条码不在列表中,是否继续添加?",
    "2892": "未能匹配相应的退换货单，是否继续?",
    "2893": "商品金额",
    "2894": "订单优惠金额",
    "2895": "商品优惠金额",
    "2896": "商品总金额",
    "2897": "零售价合计",
    "2898": "请勾选一条赠品！",
    "2899": "只能勾选一条赠品！",
    "2900": "数量不能为空，请输入！",
    "2901": "换吊牌的实际条码总拣货数为",
    "2902": "不等于原始条码的拣货数",
    "2903": "请勾选至少两笔订单进行",
    "2904": "Hold单时间",
    "2905": "Hold单原因",
    "2906": "异常原因",
    "2907": "复制类型",
    "2908": "补发类型",
    "2909": "预售付定金时间",
    "2910": "阶段付款状态",
    "2911": "合并的平台单号",
    "2912": "是否将所选订单批量增加",
    "2913": "原单必须为取消/作废状态才可进行",
    "2914": "原单必须为非取消/作废状态才可进行",
    "2915": "已选中的第",
    "2916": "行没有可拆分的订单",
    "2917": "只有等待退货入库状态可以从WMS撤回!",
    "2918": "出库拣货单",
    "2919": "号箱",
    "2920": "未扫描商品不存在",
    "2921": "条码或国标码",
    "2922": "扫描数量已超出",
    "2923": "数量不能大于1",
    "2924": "已扫描",
    "2925": "当前拣货箱不存在条码",
    "2926": "不允许为负值",
    "2927": "当前拣货箱不存在箱号",
    "2928": "入库拣货单",
    "2929": "是否确定",
    "2930": "组合-成分品",
    "2931": "订单类型",
    "2932": "平台标记",
    "2933": "收货人门牌号",
    "2934": "收货人公司",
    "2935": "详情",
    "2936": "请选择需要操作的明细！",
    "2937": "错发强制匹配一次只能选中一条明细！",
    "2938": "请选择一条数据",
    "2939": "请选择数据后再操作！",
    "2940": "无名件入库结果单详情",
    "2941": "退货金额不能大于",
    "2942": "已存在，请重新输入",
    "2943": "是否确认给所选订单打上",
    "2944": "是否确认将所选订单取消",
    "2945": "至少保留一条明细！",
    "2946": "顾客退款",
    "2947": "退款时间",
    "2948": "【指定数量】不能大于【销售数量】",
    "2949": "当前订单状态不允许修改预计发货时间！",
    "2950": "请选择要通知发货的指定商品！",
    "2951": "是否确认通知发货？",
    "2952": "请选择一条单据进行【{}】操作！",
    "2953": "不支持批量【{}】操作，请选择一条单据！",
    "2954": "请选择至少一条单据进行【{}】操作！",
    "2955": "已选中{}条订单，是否确认执行【{}】操作?",
    "2956": "退货单号为{}的，{}",
    "2957": "当前第{}行数据的 开始生产日期为【{}】，填写错误，请重新填写！",
    "2958": "当前第{}行数据的 结束生产日期为【{}】，填写错误，请重新填写！",
    "2959": "当前第{}行数据的第{}条明细 生产日期为【{}】，填写错误，请重新填写！",
    "2960": "当前单据为{}，是否进行换单！",
    "2961": "上传图片只能是{}格式！",
    "2962": "上传图片大小不能超过{}MB！",
    "2963": "退货单号",
    "2964": "是否继续？",
    "2965": "客服卡单-疫情停发",
    "2966": "客服卡单-延期等通知",
    "2967": "审单卡单-疫情停发",
    "2968": "客服卡单-运营要求",
    "2969": "销管卡单-运营要求",
    "2970": "审单卡单-运营要求",
    "2971": "虚拟入库未入库",
    "2972": "SN编码",
    "2973": "批次",
    "2974": "批次明细",
    "2975": "EXCEL导入",
    "2976": "原始订单ID",
    "2977": "原始订单明细ID",
    "2978": "订单明细ID",
    "2979": "条码名称",
    "2980": "商品单价",
    "2981": "平台退款金额",
    "2982": "订单承担优惠",
    "2983": "商家承担优惠",
    "2984": "差价金额",
    "2985": "商品退款金额",
    "2986": "现金券",
    "2987": "扣款金额",
    "2988": "提前还款",
    "2989": "确认丢件",
    "2990": "是否货物找回",
    "2991": "现金优惠券",
    "2992": "折扣金额",
    "2993": "实际商品退款金额",
    "2994": "定制内容",
    "2995": "换货单价",
    "2996": "物流状态",
    "2997": "签收时间",
    "2998": "签收日期选择",
    "2999": "实际入库商品",
    "3000": "全部通知",
    "3001": "指定商品通知",
    "3002": "打印人",
    "3003": "打印时间",
    "3004": "自动匹配",
    "3005": "错发扫描处理",
    "3006": "处理意见",
    "3007": "请填写处理意见！",
    "3008": "原SN/IMSI信息",
    "3009": "新SN/IMSI信息",
    "3010": "批量更新SN/IMEI码",
    "3011": "请选择数据执行【{}】操作！",
    "3012": "只能选择一条数据执行【{}】操作！",
    "3013": "确认执行【{}】操作吗？",
    "3014": "工单确认",
    "3015": "工单已确认，不允许保存!",
    "3016": "请输入条码对应的物料代码！",
    "3017": "工单状态待确认，不允许确认!",
    "3018": "请选择处理方式!",
    "3019": "单据已作废!",
    "3020": "单据不为待确认，不允许作废!",
    "3021": "单据不为待确认，不允许删除!",
    "3022": "请选择需要删除的明细!",
    "3023": "LMA工单",
    "3024": "处理方式",
    "3025": "处理描述",
    "3026": "处理类型不为待客服处理,不允许同意退换货!",
    "3027": "理赔时间",
    "3028": "理赔款FSC单号",
    "3029": "理赔金额",
    "3030": "ERP订单生成日期",
    "3031": "ERP订单号",
    "3032": "请填写{}！",
    "3033": "取消标记",
    "3034": "退款失败",
    "3035": "请输入SN/IMEI信息",
    "3036": "是否确认更新IMEI信息，更新后会重新进行延保信息！",
    "3037": "查询来源单据",
    "3038": "不冻结",
    "3039": "拆单方式",
    "3040": "不拆单",
    "3041": "可拆单",
    "3042": "赠品后发",
    "3043": "发货时点",
    "3044": "主品平台发货后",
    "3045": "主品签收后发",
    "3046": "主品发货后多久发",
    "3047": "间隔时长(小时)",
    "3048": "发货时点或间隔时长不能为空！",
    "3049": "设置分组",
    "3050": "促销编号",
    "3051": "活动日期",
    "3052": "选择日期范围",
    "3053": "商品",
    "3054": "促销名称",
    "3055": "促销大类",
    "3056": "促销中类",
    "3057": "操作人",
    "3058": "促销状态",
    "3059": "保存草稿",
    "3060": "发布",
    "3061": "无商品数据，禁止操作",
    "3062": "起始时间",
    "3063": "反选",
    "3064": "平台SPU编码",
    "3065": "平台SKU编码",
    "3066": "平台SPU名称",
    "3067": "商品状态",
    "3068": "销售中",
    "3069": "仓库中",
    "3070": "是否系统组合商品",
    "3071": "促销执行明细",
    "3072": "中的",
    "3073": "件商品",
    "3074": "可选促销列表",
    "3075": "试算",
    "3076": "重选",
    "3077": "应收价",
    "3078": "参与收货仓",
    "3079": "只能选取一条数据!",
    "3080": "促销标签",
    "3081": "促销说明",
    "3082": "优惠方式",
    "3083": "是否享受VIP折上折",
    "3084": "优惠基础",
    "3085": "是否执行会员一口价",
    "3086": "是否参与积分抵扣",
    "3087": "是否参与会员一口价计价",
    "3088": "适用渠道",
    "3089": "允许最大翻倍",
    "3090": "请输入备注说明",
    "3091": "请输入活动名称",
    "3092": "请选择活动日期",
    "3093": "请选择活动频次",
    "3094": "请选择促销标签",
    "3095": "请选择促销说明",
    "3096": "请完善商品条件信息",
    "3097": "单据类型或时间类型不能为空",
    "3098": "排名不能为空",
    "3099": "请录入商品数据！",
    "3100": "并且",
    "3101": "条数超限",
    "3102": "特价",
    "3103": "保存行",
    "3104": "删除选中行",
    "3105": "请按模版填写",
    "3106": "请先选择要导入的文件！",
    "3107": "请选择要删除的信息",
    "3108": "排名在",
    "3109": "之间",
    "3110": "购买",
    "3111": "分组名称",
    "3112": "活动名称",
    "3113": "参与店铺",
    "3114": "原分组名称",
    "3115": "优先级",
    "3116": "请填写分组名称！",
    "3117": "有重复优先级！",
    "3118": "设置分组成功！",
    "3119": "校验完成",
    "3120": "获取促销详情异常",
    "3121": "编辑促销活动",
    "3122": "商品列表",
    "3123": "【满足条件】至少要选中一项并且填写数量或金额条件",
    "3124": "无数据",
    "3125": "赠品列表",
    "3126": "表格",
    "3127": "数量规则未填写",
    "3128": "基础信息",
    "3129": "条件信息",
    "3130": "活动概览",
    "3131": "最大翻倍数未填写！",
    "3132": "请先添加商品和赠品！",
    "3133": "商品列表无数据",
    "3134": "赠品列表无数据",
    "3135": "批量新增促销活动",
    "3136": "活动时间段",
    "3137": "失效下线时间",
    "3138": "剩余可送",
    "3139": "已送数量",
    "3140": "状态",
    "3141": "操作描述",
    "3142": "草稿",
    "3143": "已发布",
    "3144": "下线",
    "3145": "平台SKU名称",
    "3146": "间隔时长（小时）",
    "3147": "每次赠送数量",
    "3148": "赠送总计数量",
    "3149": "顺序号",
    "3150": "商品数据编号",
    "3151": "商品标题",
    "3152": "平台款号ID",
    "3153": "平台条码ID",
    "3154": "赠品商品编码",
    "3155": "赠送SPU名称",
    "3156": "排除省",
    "3157": "赠品信息",
    "3158": "活动名称未填写！",
    "3159": "店铺名称未填写！",
    "3160": "订单类型必选！",
    "3161": "时间范围未填写",
    "3162": "下线时间未填写！",
    "3163": "最大限制次数未填写！",
    "3164": "分组",
    "3165": "线下门店",
    "3166": "下线/过期",
    "3167": "参与商品",
    "3168": "批量新增",
    "3169": "复制",
    "3170": "模拟仿真",
    "3171": "查看日志",
    "3172": "请至少选择一个",
    "3173": "选择的促销活动已经下线/过期",
    "3174": "确定执行下线操作？",
    "3175": "新增促销活动",
    "3176": "选择的促销活动已经发布",
    "3177": "存在【下线过期】的促销，请重新选择",
    "3178": "仿真试算",
    "3179": "收货省份",
    "3180": "试算成功！",
    "3181": "店铺信息未填写",
    "3182": "时间类型未填写",
    "3183": "订单类型未填写",
    "3184": "收货省份未填写",
    "3185": "商品列表数据不能为空",
    "3186": "商品列表第",
    "3187": "行数据未填写完毕",
    "3188": "批量导入解析出现问题",
    "3189": "批量新增条件信息导入",
    "3190": "添加阶梯",
    "3191": "删除阶梯",
    "3192": "添加搭配",
    "3193": "删除搭配",
    "3194": "平台SKUID",
    "3195": "系统商品款号",
    "3196": "条件信息导入",
    "3197": "取消分组",
    "3198": "批量活动下线",
    "3199": "取消发布",
    "3200": "配销中心",
    "3201": "经销商",
    "3202": "下线过期",
    "3203": "已下线的促销活动不能取消发布",
    "3204": "请选择已发布状态的促销活动取消发布",
    "3205": "确定执行取消发布操作？",
    "3206": "请选择一个",
    "3207": "请选择已发布状态的促销活动刷新",
    "3208": "请选择一条数据进行复制操作",
    "3209": "选择活动类型",
    "3210": "设置促销活动",
    "3211": "试算并发布",
    "3212": "模拟订单设置",
    "3213": "购买排名",
    "3214": "试算执行结果",
    "3215": "下线时间",
    "3216": "活动类型",
    "3217": "梯度赠送",
    "3218": "订单备注",
    "3219": "备注内容",
    "3220": "（为空不做控制，关键字依次填写，用中文“；”隔开）",
    "3221": "单个买家参与活动次数",
    "3222": "最大次数",
    "3223": "条件信息设置",
    "3224": "商品来源",
    "3225": "赠品翻倍",
    "3226": "最大翻倍次数",
    "3227": "赠送方式",
    "3228": "赠品信息设置",
    "3229": "阶梯类型",
    "3230": "赠送总量",
    "3231": "添加活动SKU",
    "3232": "商品参与方式",
    "3233": "选择商品方式",
    "3234": "商品池设置",
    "3235": "执行促销",
    "3236": "吊牌金额",
    "3237": "零售金额",
    "3238": "活动频次",
    "3239": "预售天数",
    "3240": "活动范围",
    "3241": "参与时间范围",
    "3242": "活动方案",
    "3243": "是否与其他商品活动同时执行",
    "3244": "是否与全场活动同时执行",
    "3245": "换购条件",
    "3246": "条件商品来源",
    "3247": "优惠商品来源",
    "3248": "换购",
    "3249": "商品来源类型",
    "3250": "活动扣点",
    "3251": "是否与优惠券同享",
    "3252": "备注说明",
    "3253": "不限",
    "3254": "仅限同款",
    "3255": "仅限同吊牌价",
    "3256": "享受",
    "3257": "折",
    "3258": "大于等于",
    "3259": "大于",
    "3260": "等于",
    "3261": "重导",
    "3262": "商品不能为空",
    "3263": "特价不能为空",
    "3264": "最多导入10000条数据",
    "3265": "上传文件不是指定文件类型！",
    "3266": "上传文件大小不能超过 2MB",
    "3267": "商品特价导入模版",
    "3268": "请先选择要导入的文件",
    "3269": "暂无要导出的商品",
    "3270": "商品特价导出",
    "3271": "立享",
    "3272": "花呗分期",
    "3273": "免息",
    "3274": "3期",
    "3275": "6期",
    "3276": "12期",
    "3277": "类",
    "3278": "A类",
    "3279": "立享第1件",
    "3280": "以上",
    "3281": "第",
    "3282": "立减",
    "3283": "加",
    "3284": "优惠",
    "3285": "免",
    "3286": "排除商品",
    "3287": "购买商品",
    "3288": "购买 ",
    "3289": "类商品",
    "3290": "优惠商品",
    "3291": "赠送券",
    "3292": "张",
    "3293": "券",
    "3294": "赠送商品",
    "3295": "换购商品",
    "3296": "全场",
    "3297": "的商品，",
    "3298": "立享满",
    "3299": "满足",
    "3300": "标准商品档案",
    "3301": "线上促销详情",
    "3302": "组",
    "3303": "请勾选需要操作的数据！",
    "3304": "金额",
    "3305": "查询数量已超过",
    "3306": "上限，请修改查询条件",
    "3307": "第{}行数据未填写完毕",
    "3308": "商品列表第{}组第{}行数据未填写完毕",
    "3309": "赠品列表第{}组第{}行数据未填写完毕",
    "3310": "促销[{}]参与的商品有[{}],共优惠{}元",
    "3311": "该订单已满足【买赠】促销[{}],可赠送{}",
    "3312": "赠品信息导入",
    "3313": "按周",
    "3314": "按天",
    "3315": "周一",
    "3316": "周二",
    "3317": "周三",
    "3318": "周四",
    "3319": "周五",
    "3320": "周六",
    "3321": "周日",
    "3322": "每",
    "3323": "梯度送",
    "3324": "仅限VIP生日当日",
    "3325": "仅限VIP生日当周",
    "3326": "仅限VIP生日当月",
    "3327": "仅限活动日期",
    "3328": "自定义时间范围",
    "3329": "梯度换",
    "3330": "全部换",
    "3331": "商家最优",
    "3332": "顾客最优",
    "3333": "小程序",
    "3334": "最近一周",
    "3335": "最近一个月",
    "3336": "最近三个月",
    "3337": "仅限会员",
    "3338": "是否积分",
    "3339": "参与仓库",
    "3340": "会员等级",
    "3341": "线上店铺",
    "3342": "当前记录无明细，不允许审核",
    "3343": "商品导出",
    "3344": "当前的操作会执行全量导出，导出时间可能会比较慢！是否继续导出?",
    "3345": "导出成功！",
    "3346": "我的任务",
    "3347": "数据导出中",
    "3348": "库存日期",
    "3349": "店铺编码",
    "3350": "请选择库存日期！",
    "3351": "请选择查询时间",
    "3352": "日",
    "3353": "周",
    "3354": "月",
    "3355": "昨天",
    "3356": "7天",
    "3357": "30天",
    "3358": "库存总量",
    "3359": "款号",
    "3360": "款色",
    "3361": "销售额",
    "3362": "销售指标",
    "3363": "指标完成率",
    "3364": "销售件数",
    "3365": "小程序销售金额",
    "3366": "员工数",
    "3367": "人均产出",
    "3368": "本店",
    "3369": "今日",
    "3370": "工业绩",
    "3371": "营业员",
    "3372": "销售金额",
    "3373": "销售金额占比",
    "3374": "小票总单数",
    "3375": "连带率",
    "3376": "客单价",
    "3377": "Top次数",
    "3378": "畅销款TOP10",
    "3379": "销售收入",
    "3380": "收入占比",
    "3381": "数量占比",
    "3382": "平均折扣",
    "3383": "平均售价",
    "3384": "数据时间",
    "3385": "业绩",
    "3386": "批量删除",
    "3387": "批量增加",
    "3388": "选择店仓",
    "3389": "应用店铺",
    "3390": "请先选择店仓或店铺！",
    "3391": "付款时间为必填项,没有选择值!",
    "3392": "付款时间范围有误!",
    "3393": "订单金额（元）为必填项,没有输入值!",
    "3394": "订单金额范围设置有误!",
    "3395": "收货地址为必填项,没有输入值!",
    "3396": "提示信息",
    "3397": "物流公司明细",
    "3398": "可发物流公司",
    "3399": "不做要求",
    "3400": "排除物流公司",
    "3401": "请选择需要批量修改的单据记录！",
    "3402": "请添加物流公司！",
    "3403": "该物流公司已存在!",
    "3404": "开始时间（包含）",
    "3405": "结束时间（不包含）",
    "3406": "开始时间",
    "3407": "结束时间",
    "3408": "请选择开始时间或结束时间！",
    "3409": "开始时间必须小于结束时间！",
    "3410": "延期日期",
    "3411": "延期",
    "3412": "点击了取消!",
    "3413": "类型",
    "3414": "指定客户",
    "3415": "所有客户",
    "3416": "经营模式",
    "3417": "配销仓回退规则",
    "3418": "实体仓编码",
    "3419": "配销仓编码",
    "3420": "配销仓名称",
    "3421": "聚合仓编码",
    "3422": "聚合仓名称",
    "3423": "寻源规则",
    "3424": "前往设置仓库配送范围",
    "3425": "当前没有历史记录！",
    "3426": "请选择客户",
    "3427": "请先添加寻源仓库范围数据",
    "3428": "是否同意保存当前页面的数据？",
    "3429": "明细无数据，无法导出",
    "3430": "优先级不能相同",
    "3431": "请选择配销仓",
    "3432": "请先选择需要删除的数据!",
    "3433": "仅支持选择一项寻源规则！",
    "3434": "当前修改未保存，确定关闭？",
    "3435": "存在相互冲突的价格区间,请调整!",
    "3436": "只能选择一条数据！",
    "3437": "自动审核时间",
    "3438": "商品级别",
    "3439": "品类",
    "3440": "邮编类型",
    "3441": "邮编前几位",
    "3442": "配送区域类型",
    "3443": "国家明细",
    "3444": "请选择需要删除的明细！",
    "3445": "出现尚未保存的变更，是否仍要返回？",
    "3446": "前往设置评分策略",
    "3447": "计算公式：(店仓各评分因子值*权重)之和，决定各店仓的评分值",
    "3448": "指定仓库批次",
    "3449": "前往设置指定仓库批次",
    "3450": "指定仓库批次设置",
    "3451": "针对存在保质期商品，优先整单满足指定批次范围的仓库",
    "3452": "最小拆包数",
    "3453": "整单不满足情况下按照最小拆包数拆单",
    "3454": "暂无",
    "3455": "关闭寻源",
    "3456": "更新优先级",
    "3457": "启用寻源",
    "3458": "寻源",
    "3459": "供货",
    "3460": "设置优先级",
    "3461": "寻源&供货",
    "3462": "仅寻源",
    "3463": "仅供货",
    "3464": "启用寻源仓",
    "3465": "关闭寻源仓",
    "3466": "添加到已选列表",
    "3467": "共享比例",
    "3468": "保底库存",
    "3469": "已选条码",
    "3470": "已选方案",
    "3471": "不填则应用于所有已生效方案",
    "3472": "应用方案",
    "3473": "选择条码",
    "3474": "设置共享比例（%）",
    "3475": "设置保底库存数",
    "3476": "请先添加到已选列表！",
    "3477": "是否确认此操作？",
    "3478": "请设置共享比例！",
    "3479": "请设置保底库存数！",
    "3480": "请选择条码！",
    "3481": "已选仓库",
    "3482": "已选店铺",
    "3483": "已选中批量修改记录数",
    "3484": "行",
    "3485": "平台特殊",
    "3486": "未勾选记录,将批量更新所有查询结果",
    "3487": "共计",
    "3488": "行,是否确定继续操作",
    "3489": "默认发货逻辑仓",
    "3490": "占库存方法",
    "3491": "整单占",
    "3492": "部分占",
    "3493": "订单路由方案",
    "3494": "就近判断",
    "3495": "就全+就近判断",
    "3496": "缺货自动拆单",
    "3497": "默认退货实体仓",
    "3498": "启用GA(SA)",
    "3499": "寄售逻辑仓",
    "3500": "分仓模式",
    "3501": "按仓库库存就全",
    "3502": "按仓库优先级",
    "3503": "时效单释放时长",
    "3504": "未修改任何参数!",
    "3505": "自动审核货到付款",
    "3506": "排除实体仓",
    "3507": "排除业务单据类型",
    "3508": "包含关键字进行人工审核；多个关键字可依次填写，使用中文“，”隔开",
    "3509": "为空默认为有备注信息进行人工审核；多个关键字可依次填写，使用中文“，”隔开。",
    "3510": "生效结束时间",
    "3511": "策略",
    "3512": "寻源仓库范围",
    "3513": "回退配销仓范围",
    "3514": "点击添加行记录",
    "3515": "添加寻源规则行",
    "3516": "请输入支付时间",
    "3517": "等于关键字进行人工审核；多个关键字可依次填写，使用中文“，”隔开。",
    "3518": "类型值",
    "3519": "请输入值查询",
    "3520": "启用自动审核",
    "3521": "检查可合并订单",
    "3522": "全赠品订单开启自动审核",
    "3523": "修改时间后，延长一段时间再执行审核的时间",
    "3524": "用户执行反审核后，延长一段时间再执行重新审核的时间",
    "3525": "hold单等待时间",
    "3526": "手工订单",
    "3527": "订单折扣范围",
    "3528": "订单金额（元）",
    "3529": "收货地址",
    "3530": "买家留言",
    "3531": "自定义标签",
    "3532": "单条码数量上限",
    "3533": "限制商品信息",
    "3534": "固定时间",
    "3535": "商品标题/规格名称中可用特殊符号和文字",
    "3536": "渠道仓",
    "3537": "库存比例",
    "3538": "插入字段",
    "3539": "内容",
    "3540": "请选择省市区",
    "3541": "添加商品",
    "3542": "SPU编码/条码",
    "3543": "SPU名称/SKU名称",
    "3544": "JIT订单下发通知",
    "3545": "检索",
    "3546": "请确认是否需要删除仓库",
    "3547": "请确认是否需要删除物流公司",
    "3548": "策略参数选择",
    "3549": "寻源策略维护",
    "3550": "配销仓寻源策略",
    "3551": "设置寻源的配销仓范围",
    "3552": "配销仓寻源优先级设置",
    "3553": "前往配销仓寻源设置优先级策略",
    "3554": "流程图",
    "3555": "寻源规则 的优先级不能为空！",
    "3556": "寻源规则 的优先级不能相同！",
    "3557": "店优先，仓优先只能关闭其中一个规则，不能全部关闭！",
    "3558": "寻源定义编辑",
    "3559": "寻源策略定义（新）",
    "3560": "强制排除店仓规则",
    "3561": "寻源排除逻辑仓，被排除的逻辑仓不再参与订单寻源",
    "3562": "整单优先分配指定批次的仓库",
    "3563": "优先级高的实体仓优先发货",
    "3564": "寻源规则策略",
    "3565": "整单优先分配满足就近，仓辐射等寻源规则的仓库",
    "3566": "店仓评分策略",
    "3567": "店仓评分值高的实体仓优先发货",
    "3568": "整单优先",
    "3569": "开启后优先整单优先，整单不满足时再按照执行优先级顺序执行寻源类型。",
    "3570": "请选中一项寻源规则！",
    "3571": "规则已经存在！",
    "3572": "实体店仓",
    "3573": "物流公司",
    "3574": "延期日期不能为空！",
    "3575": "订单时间",
    "3576": "调整结束时间",
    "3577": "点击了取消！",
    "3578": "调整策略时间成功",
    "3579": "店仓档案",
    "3580": "策略名称",
    "3581": "启动自动审核",
    "3582": "{str} 不能为空",
    "3583": "金额区间不能小于{x}",
    "3584": "生效开始时间",
    "3585": "最低成交价格",
    "3586": "最低成交单价",
    "3587": "商品明细",
    "3588": "时间类型",
    "3589": "按系统创建时间等待",
    "3590": "支付时间",
    "3591": "单据标签",
    "3592": "释放时间",
    "3593": "指定时间点",
    "3594": "固定时长",
    "3595": "预售HOLD单",
    "3596": "据预计发货时间提前",
    "3597": "赠送积分",
    "3598": "订单标签",
    "3599": "店铺名称不能为空，请填写",
    "3600": "固定时长类型,固定时长及单位不能为空,请填写",
    "3601": "直播商品识别",
    "3602": "识别规则",
    "3603": "主播ID",
    "3604": "请录入主播ID",
    "3605": "主播昵称",
    "3606": "请录入主播昵称",
    "3607": "“播”标",
    "3608": "请勿重复添加直播商品识别规则!",
    "3609": "添加排除区域",
    "3610": "排除区域",
    "3611": "支持省份",
    "3612": "排除省份",
    "3613": "删除区域",
    "3614": "支持范围",
    "3615": "全国（含港澳台地区）",
    "3616": "自定义",
    "3617": "添加支持省份",
    "3618": "配送省份",
    "3619": "排除具体区域",
    "3620": "配送区域",
    "3621": "排除地区",
    "3622": "请选择要删除的明细",
    "3623": "分钟后自动审核",
    "3624": "只能选择一条数据",
    "3625": "请选择排除省份",
    "3626": "物流派送范围编辑",
    "3627": "修改内容",
    "3628": "修改前",
    "3629": "修改后",
    "3630": "已启用订单折扣限制，订单折扣范围不可为空",
    "3631": "起始折扣应小于或等于截止折扣",
    "3632": "付款时间为必填项,没有选择值",
    "3633": "付款时间范围有误",
    "3634": "已启用订单金额限制，订单金额不可为空",
    "3635": "起始金额应小于或等于截止金额",
    "3636": "收货地址为必填项,没有输入值",
    "3637": "请选择需要删除的数据",
    "3638": "日程规划名称",
    "3639": "规划开始时间",
    "3640": "规划结束时间",
    "3641": "大促",
    "3642": "日常",
    "3643": "补货独立入库",
    "3644": "自动补货数量限制",
    "3645": "拣货单创建时间",
    "3646": "唯品会仓库",
    "3647": "未拣货数维度",
    "3648": "PO维度",
    "3649": "单PO下唯品会仓库维度",
    "3650": "创建峰值",
    "3651": "自动拣货间隔时间",
    "3652": "创建条件",
    "3653": "当“店铺+唯品会仓库+发货仓库”相同的配货单中商品数量大于等于设置的峰值时，自动创建入库单",
    "3654": "创建内容",
    "3655": "空运",
    "3656": "汽运",
    "3657": "发货间隔",
    "3658": "当日",
    "3659": "次日",
    "3660": "到货间隔",
    "3661": "到货时间",
    "3662": "入库单结单",
    "3663": "每天在该时间点自动对创建的入库单结单",
    "3664": "确定删除？",
    "3665": "拣货单创建方式",
    "3666": "当前切换操作会清空已录入的按时间点创建/按未拣货数创建内容，确定继续吗？",
    "3667": "按时间点创建",
    "3668": "按未拣货数创建",
    "3669": "用户名",
    "3670": "日志类型",
    "3671": "修改人名称",
    "3672": "拣货单",
    "3673": "规则名称",
    "3674": "收货地址就近",
    "3675": "唯品会",
    "3676": "修改仓库",
    "3677": "仓库优先级",
    "3678": "发货比例",
    "3679": "发货数量",
    "3680": "按收货地址",
    "3681": "规则名称必填",
    "3682": "规则类型必填",
    "3683": "请先设置仓库",
    "3684": "订单派单规则编辑",
    "3685": "请先保存主表信息",
    "3686": "仓库必填",
    "3687": "仓库优先级必填必填",
    "3688": "新增成功",
    "3689": "新增失败",
    "3690": "派单规则明细",
    "3691": "分仓比例",
    "3692": "优先级设置重复！",
    "3693": "作废成功！",
    "3694": "作废失败！",
    "3695": "导出失败！",
    "3696": "删除失败！",
    "3697": "订单号",
    "3698": "入库单号",
    "3699": "到货仓",
    "3700": "商品总数量",
    "3701": "本单件数",
    "3702": "原单件数",
    "3703": "入库日期",
    "3704": "满足条件",
    "3705": "执行动作",
    "3706": "普通订单",
    "3707": "预售订单",
    "3708": "货到付款订单",
    "3709": "日期类型",
    "3710": "下单日期",
    "3711": "时间范围",
    "3712": "指定地址",
    "3713": "包含",
    "3714": "排除",
    "3715": "所在省",
    "3716": "所在市",
    "3717": "包裹属性",
    "3718": "开始值 大于等于",
    "3719": "结束值",
    "3720": "区间范围",
    "3721": "商品数量",
    "3722": "至",
    "3723": "件",
    "3724": "单据金额",
    "3725": "元",
    "3726": "包裹重量",
    "3727": "城市",
    "3728": "请选择要删除的仓库物流公司！",
    "3729": "启用状态，不可删除！",
    "3730": "请填写",
    "3731": "请选择单据类型",
    "3732": "请填写时间范围",
    "3733": "请填写您选中的开始值和结束值",
    "3734": "结束值需大于等于开始值",
    "3735": "特殊物流方案新增",
    "3736": "请选择要添加仓库物流",
    "3737": "请选择需要添加的数据",
    "3738": "启用状态，不可编辑",
    "3739": "省市搜索",
    "3740": "区域级别",
    "3741": "分仓策略-导入",
    "3742": "分仓规则编辑",
    "3743": "区域明细",
    "3744": "请输入唯品会仓库名称！",
    "3745": "换货地址",
    "3746": "请先选择店铺",
    "3747": "换货说明",
    "3748": "偏差N元同意换货<=",
    "3749": "有",
    "3750": "没有",
    "3751": "缺货自动拒绝",
    "3752": "缺货自动拒绝换货原因",
    "3753": "缺货自动拒绝文案",
    "3754": "偏差N元自动拒绝",
    "3755": "偏差N元拒绝换货>",
    "3756": "偏差N元自动拒绝换货原因",
    "3757": "偏差N元自动拒绝文案",
    "3758": "物流分配",
    "3759": "默认物流",
    "3760": "启用物流",
    "3761": "物流信息",
    "3762": "仓库编号",
    "3763": "物流编号",
    "3764": "生效日期",
    "3765": "结束日期",
    "3766": "方案名称",
    "3767": "方案描述",
    "3768": "结案人",
    "3769": "结案时间",
    "3770": "赔付类型",
    "3771": "价格赔付",
    "3772": "邮费赔付",
    "3773": "固定结算",
    "3774": "赔付标准",
    "3775": "邮费",
    "3776": "倍数",
    "3777": "结算价",
    "3778": "快递赔付方案",
    "3779": "实体仓不能为空",
    "3780": "生效日期不能为空",
    "3781": "结束日期不能为空",
    "3782": "方案名称不能为空",
    "3783": "明细为空不允许保存",
    "3784": "赔付标准和倍数不能为空",
    "3785": "结算价不能为空",
    "3786": "快递公司名称不能为空",
    "3787": "物流区域设置",
    "3788": "物流公司必填！",
    "3789": "数量过大，请使用导入功能设置是否到达！",
    "3790": "仓库物流优先级设置",
    "3791": "请选择物流区域！",
    "3792": "的物流优先级为空,保存会导致该数据删除,是否确认保存？",
    "3793": "修改物流",
    "3794": "基础资料",
    "3795": "零元订单自动审核",
    "3796": "等待审核时间",
    "3797": "反审核等待时间",
    "3798": "限制条件",
    "3799": "满足以下条件的订单需要人工审核",
    "3800": "是否正常订单",
    "3801": "是否预售订单",
    "3802": "是否换货订单",
    "3803": "订单金额",
    "3804": "条数据",
    "3805": "单据创建方式",
    "3806": "手工导入",
    "3807": "手工新增",
    "3808": "总金额",
    "3809": "满足以下条件的单据会进行hold单",
    "3810": "直播",
    "3811": "定预",
    "3812": "全预",
    "3813": "自预",
    "3814": "满足以下条件的单据打“播”标",
    "3815": "正常订单",
    "3816": "换货订单",
    "3817": "预售识别规则",
    "3818": "付款后",
    "3819": "自定义关键字",
    "3820": "清空明细",
    "3821": "系统SPU编码",
    "3822": "请输入识别内容，多关键字使用中文“，”隔开",
    "3823": "自动确认退货(仓库回传退货入库结果后，系统自动完成退货确认的业务操作)",
    "3824": "创建入库单",
    "3825": "渠道仓 - 库存比例",
    "3826": "安全库存数",
    "3827": "指定商品",
    "3828": "自动同意换货",
    "3829": "自动拒绝换货",
    "3830": "明细信息",
    "3831": "是否确认导出？",
    "3832": "经销",
    "3833": "代销",
    "3834": "联营",
    "3835": "配销仓优先级",
    "3836": "配销仓库存权重",
    "3837": "就近原则",
    "3838": "优先级不能为空，请维护",
    "3839": "存在相同的优先级，请修改",
    "3840": "TOB寻源定义编辑",
    "3841": "TOB寻源策略",
    "3842": "请选择实体仓或逻辑仓",
    "3843": "存在相同的【实体仓+逻辑仓】，请修改",
    "3844": "存在相同的【配销仓】，请修改",
    "3845": "不能为空",
    "3846": "买家留言为必填项,没有输入值!",
    "3847": "卖家备注为必填项,没有输入值!",
    "3848": "该组合已存在",
    "3849": "保存失败",
    "3850": "未发生变更，请变更后点击【确定】",
    "3851": "已存在，请重新设置",
    "3852": "删除条码",
    "3853": "仓优先 或 寻源规则 的优先级不能为空！",
    "3854": "明细中{}不能为空",
    "3855": "字段不能为空，请填写",
    "3856": "就全原则",
    "3857": "仓库配送范围设置",
    "3858": "同成本中心",
    "3859": "仓库评分",
    "3860": "门店评分",
    "3861": "门店等级",
    "3862": "店铺类型",
    "3863": "折扣店优先级高于正价店",
    "3864": "就近原则：区县->市区->省份->仓库配送范围；TOC仓辐射：按照商品、商品属性及省份设置仓库寻源优先级",
    "3865": "数字越大优先级越高！",
    "3866": "寻源类型",
    "3867": "店优先",
    "3868": "时",
    "3869": "“hold”标",
    "3870": "入库单创建时间",
    "3871": "最多只能添加5条!",
    "3872": "等待时间无效!",
    "3873": "时间类型及时间",
    "3874": "时间类型的时间不能为空，请填写！",
    "3875": "释放指定时间",
    "3876": "请选择原角色！",
    "3877": "请选择目的角色！",
    "3878": "目的角色不能包含原角色，请重新选择！",
    "3879": "角色",
    "3880": "刷新成功",
    "3881": "促销类型",
    "3882": "是否库存锁定",
    "3883": "库存同步比例",
    "3884": "平台店铺名称",
    "3885": "规格描述",
    "3886": "系统商品",
    "3887": "系统商品名称",
    "3888": "系统规格名称",
    "3889": "环境",
    "3890": "环境不能为空！",
    "3891": "图片格式",
    "3892": "图片大小",
    "3893": "建议图片尺寸",
    "3894": "保存并立即应用",
    "3895": "真实姓名",
    "3896": "联系方式",
    "3897": "异常操作",
    "3898": "异常操作原因",
    "3899": "不少于10个汉字",
    "3900": "您已明确该项操作的后果，愿意承担相应的责任，请慎重使用！",
    "3901": "请填写真实姓名！",
    "3902": "请填写正确的手机号！",
    "3903": "操作理由不能少于10个汉字！",
    "3904": "请阅读警告信息，若同意请勾选！",
    "3905": "异常处理",
    "3906": "填写单据ID,以逗号分隔，如：20201235001,20201235002",
    "3907": "按单据编号导入,以逗号分隔，如：RE20201235001,RE20201235002",
    "3908": "按店铺ID，逗号分隔；如：13345,13355,1678...",
    "3909": "日期",
    "3910": "按日期导入，逗号分隔；如：20200508，20200509，20200515...",
    "3911": "用户与商品",
    "3912": "请输入角色",
    "3913": "请输入商品",
    "3914": "共",
    "3915": "请选择复制方式",
    "3916": "店仓权限",
    "3917": "供应商权限",
    "3918": "配销中心权限",
    "3919": "品牌权限",
    "3920": "商品权限",
    "3921": "公司权限",
    "3922": "角色权限",
    "3923": "配销中心名称",
    "3924": "制单主店仓",
    "3925": "查看主店仓",
    "3926": "供应商编码",
    "3927": "供应商全称",
    "3928": "配销中心编码",
    "3929": "查看",
    "3930": "公司编码",
    "3931": "公司名称",
    "3932": "说明",
    "3933": "原角色",
    "3934": "目的角色",
    "3935": "复制方式",
    "3936": "覆盖原有权限",
    "3937": "保留原有权限",
    "3938": "原角色请求失败",
    "3939": "敏感列",
    "3940": "没有更改",
    "3941": "请输入机构编码或名称",
    "3942": "请输入 0 - 100 的库存同步比例值！",
    "3943": "小于",
    "3944": "上传头像图片最好是{}格式!",
    "3945": "上传头像图片大小最好不要超过{}MB!",
    "3946": "零售单重推ES",
    "3947": "零售单重调用库存",
    "3948": "店长导航数据归集",
    "3949": "按单号ID",
    "3950": "按照日期段",
    "3951": "按店铺ID",
    "3952": "按日期"
}